import { css, keyframes } from "@emotion/react";

const loadingCircleKeyframes = keyframes`
 100% {
    transform: rotate(360deg);
  }
`;

//A

export const ArchiveOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="archive">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M21 6a3 3 0 0 0-3-3H6a3 3 0 0 0-2 5.22V18a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.22A3 3 0 0 0 21 6zM6 5h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm12 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h12z" />
        <rect x="9" y="12" width="6" height="2" rx=".87" ry=".87" />
      </g>
    </g>
  </svg>
);

export const ArrowBack = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-back">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23 1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const ArrowCompareOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.18367 12.44H18.93C19.4765 12.44 19.92 12.8835 19.92 13.43C19.92 13.9765 19.4765 14.42 18.93 14.42H7.18367L10.7803 18.7364C11.1308 19.1562 11.0734 19.7809 10.6536 20.1303C10.4685 20.2848 10.2438 20.36 10.02 20.36C9.73688 20.36 9.45572 20.2382 9.2597 20.0036L4.3097 14.0636C4.27109 14.0171 4.25129 13.9626 4.22258 13.9111C4.19882 13.8696 4.17011 13.8339 4.15229 13.7884C4.10774 13.6745 4.08101 13.5547 4.08101 13.434C4.08101 13.433 4.08002 13.431 4.08002 13.43C4.08002 13.429 4.08101 13.427 4.08101 13.426C4.08101 13.3053 4.10774 13.1855 4.15229 13.0716C4.17011 13.0261 4.19882 12.9904 4.22258 12.9489C4.41566 12.6026 4.86258 12.476 5.25896 12.4699L7.18367 12.44Z" />
    <path d="M16.8964 11.52H5.15003C4.60355 11.52 4.16003 11.0764 4.16003 10.53C4.16003 9.98348 4.60355 9.53996 5.15003 9.53996H16.8964L13.2997 5.22356C12.9493 4.8038 13.0067 4.17911 13.4264 3.82964C13.6116 3.6752 13.8363 3.59996 14.06 3.59996C14.3432 3.59996 14.6243 3.72173 14.8204 3.95636L19.7704 9.89636C19.809 9.94289 19.8288 9.99734 19.8575 10.0488C19.8812 10.0904 19.9099 10.126 19.9278 10.1716C19.9723 10.2854 19.999 10.4052 19.999 10.526C19.999 10.527 20 10.529 20 10.53C20 10.5309 19.999 10.5329 19.999 10.5339C19.999 10.6547 19.9723 10.7745 19.9278 10.8883C19.9099 10.9339 19.8812 10.9695 19.8575 11.0111C19.6644 11.3573 19.2175 11.4839 18.8211 11.4901L16.8964 11.52Z" />
  </svg>
);

export const ArrowIosBackOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-back">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M13.83 19a1 1 0 0 1-.78-.37l-4.83-6a1 1 0 0 1 0-1.27l5-6a1 1 0 0 1 1.54 1.28L10.29 12l4.32 5.36a1 1 0 0 1-.78 1.64z" />
      </g>
    </g>
  </svg>
);

export const ArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-downward">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M12 17a1.72 1.72 0 0 1-1.33-.64l-4.21-5.1a2.1 2.1 0 0 1-.26-2.21A1.76 1.76 0 0 1 7.79 8h8.42a1.76 1.76 0 0 1 1.59 1.05 2.1 2.1 0 0 1-.26 2.21l-4.21 5.1A1.72 1.72 0 0 1 12 17z" />
      </g>
    </g>
  </svg>
);

export const ArrowDownFill = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 17C11.494 17 11.01 16.767 10.674 16.358L6.46103 11.26C5.95703 10.649 5.85603 9.782 6.20203 9.049C6.50703 8.402 7.11403 8 7.78703 8H16.213C16.886 8 17.493 8.402 17.798 9.049C18.144 9.782 18.043 10.649 17.54 11.259L13.326 16.358C12.99 16.767 12.506 17 12 17" />
    <mask
      id="mask0_0_2149"
      maskUnits="userSpaceOnUse"
      x="5"
      y="8"
      width="14"
      height="9"
    >
      <path d="M12 17C11.494 17 11.01 16.767 10.674 16.358L6.46103 11.26C5.95703 10.649 5.85603 9.782 6.20203 9.049C6.50703 8.402 7.11403 8 7.78703 8H16.213C16.886 8 17.493 8.402 17.798 9.049C18.144 9.782 18.043 10.649 17.54 11.259L13.326 16.358C12.99 16.767 12.506 17 12 17Z" />
    </mask>
    <g mask="url(#mask0_0_2149)"></g>
  </svg>
);

export const ArrowDownFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-downward">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M12 17a1.72 1.72 0 0 1-1.33-.64l-4.21-5.1a2.1 2.1 0 0 1-.26-2.21A1.76 1.76 0 0 1 7.79 8h8.42a1.76 1.76 0 0 1 1.59 1.05 2.1 2.1 0 0 1-.26 2.21l-4.21 5.1A1.72 1.72 0 0 1 12 17z" />
      </g>
    </g>
  </svg>
);

export const ArrowIosDownwardOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-downward">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15 1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16z" />
      </g>
    </g>
  </svg>
);

export const ArrowUpwardOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-upward">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M5.23 10.64a1 1 0 0 0 1.41.13L11 7.14V19a1 1 0 0 0 2 0V7.14l4.36 3.63a1 1 0 1 0 1.28-1.54l-6-5-.15-.09-.13-.07a1 1 0 0 0-.72 0l-.13.07-.15.09-6 5a1 1 0 0 0-.13 1.41z" />
      </g>
    </g>
  </svg>
);

export const ArrowDownwardOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-downward">
        <rect width="24" height="24" opacity="0" />
        <path d="M18.77 13.36a1 1 0 0 0-1.41-.13L13 16.86V5a1 1 0 0 0-2 0v11.86l-4.36-3.63a1 1 0 1 0-1.28 1.54l6 5 .15.09.13.07a1 1 0 0 0 .72 0l.13-.07.15-.09 6-5a1 1 0 0 0 .13-1.41z" />
      </g>
    </g>
  </svg>
);

export const ArrowDownWithStem = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.6405 11.1335C15.3455 10.7802 14.8205 10.7318 14.4672 11.0268L10.8339 14.0543V4.16683C10.8339 3.70683 10.4605 3.3335 10.0005 3.3335C9.54052 3.3335 9.16719 3.70683 9.16719 4.16683V14.0543L5.53385 11.0268C5.17969 10.7318 4.65469 10.7802 4.36052 11.1335C4.06552 11.4868 4.11302 12.0127 4.46719 12.3068L9.46719 16.4735C9.50636 16.5068 9.55302 16.5227 9.59636 16.5477C9.63052 16.5677 9.66052 16.591 9.69802 16.606C9.79552 16.6443 9.89719 16.6668 10.0005 16.6668C10.1039 16.6668 10.2055 16.6443 10.303 16.606C10.3405 16.591 10.3705 16.5677 10.4047 16.5477C10.448 16.5227 10.4947 16.5068 10.5339 16.4735L15.5339 12.3068C15.8872 12.0127 15.9355 11.4868 15.6405 11.1335" />
    <mask maskUnits="userSpaceOnUse" x="4" y="3" width="12" height="14">
      <path d="M15.6405 11.1335C15.3455 10.7802 14.8205 10.7318 14.4672 11.0268L10.8339 14.0543V4.16683C10.8339 3.70683 10.4605 3.3335 10.0005 3.3335C9.54052 3.3335 9.16719 3.70683 9.16719 4.16683V14.0543L5.53385 11.0268C5.17969 10.7318 4.65469 10.7802 4.36052 11.1335C4.06552 11.4868 4.11302 12.0127 4.46719 12.3068L9.46719 16.4735C9.50636 16.5068 9.55302 16.5227 9.59636 16.5477C9.63052 16.5677 9.66052 16.591 9.69802 16.606C9.79552 16.6443 9.89719 16.6668 10.0005 16.6668C10.1039 16.6668 10.2055 16.6443 10.303 16.606C10.3405 16.591 10.3705 16.5677 10.4047 16.5477C10.448 16.5227 10.4947 16.5068 10.5339 16.4735L15.5339 12.3068C15.8872 12.0127 15.9355 11.4868 15.6405 11.1335" />
    </mask>
    <g mask="url(#mask0_815_1646)"></g>
  </svg>
);

export const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-right">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M10.46 18a2.23 2.23 0 0 1-.91-.2 1.76 1.76 0 0 1-1.05-1.59V7.79A1.76 1.76 0 0 1 9.55 6.2a2.1 2.1 0 0 1 2.21.26l5.1 4.21a1.7 1.7 0 0 1 0 2.66l-5.1 4.21a2.06 2.06 0 0 1-1.3.46z" />
      </g>
    </g>
  </svg>
);

export const ArrowHeadRight = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9513 5.373L18.7793 11.373C19.0783 11.744 19.0733 12.274 18.7683 12.64L13.7683 18.64C13.5703 18.877 13.2863 19 12.9993 19C12.7743 19 12.5473 18.924 12.3603 18.768C11.9353 18.415 11.8783 17.784 12.2323 17.36L16.7083 11.989L12.3923 6.627C12.0463 6.197 12.1143 5.567 12.5453 5.221C12.9753 4.874 13.6043 4.943 13.9513 5.373ZM5.5452 5.221C5.9752 4.875 6.6042 4.943 6.9512 5.373L11.7792 11.373C12.0772 11.744 12.0732 12.274 11.7682 12.64L6.7682 18.64C6.5702 18.877 6.2862 19 5.9992 19C5.7742 19 5.5472 18.924 5.3602 18.768C4.9352 18.415 4.8782 17.784 5.2322 17.36L9.7072 11.989L5.3922 6.627C5.0462 6.197 5.1152 5.567 5.5452 5.221Z"
    />
    <mask
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x="5"
      y="4"
      width="15"
      height="15"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9513 5.373L18.7793 11.373C19.0783 11.744 19.0733 12.274 18.7683 12.64L13.7683 18.64C13.5703 18.877 13.2863 19 12.9993 19C12.7743 19 12.5473 18.924 12.3603 18.768C11.9353 18.415 11.8783 17.784 12.2323 17.36L16.7083 11.989L12.3923 6.627C12.0463 6.197 12.1143 5.567 12.5453 5.221C12.9753 4.874 13.6043 4.943 13.9513 5.373ZM5.5452 5.221C5.9752 4.875 6.6042 4.943 6.9512 5.373L11.7792 11.373C12.0772 11.744 12.0732 12.274 11.7682 12.64L6.7682 18.64C6.5702 18.877 6.2862 19 5.9992 19C5.7742 19 5.5472 18.924 5.3602 18.768C4.9352 18.415 4.8782 17.784 5.2322 17.36L9.7072 11.989L5.3922 6.627C5.0462 6.197 5.1152 5.567 5.5452 5.221Z"
      />
    </mask>
    <g mask="url(#mask0_0_111)"></g>
  </svg>
);

export const ArrowRightWithStem = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 9.74957L12.645 9.74958L9.9225 13.0196C9.7952 13.1727 9.73395 13.3702 9.75224 13.5685C9.77052 13.7668 9.86684 13.9498 10.02 14.0771C10.1732 14.2044 10.3706 14.2656 10.5689 14.2473C10.7673 14.2291 10.9502 14.1327 11.0775 13.9796L14.8275 9.47958C14.8527 9.44378 14.8753 9.40618 14.895 9.36708C14.895 9.32958 14.895 9.30708 14.9475 9.26958C14.9815 9.18358 14.9993 9.09204 15 8.99958C14.9993 8.90711 14.9815 8.81557 14.9475 8.72958C14.9475 8.69208 14.9475 8.66958 14.895 8.63208C14.8753 8.59297 14.8527 8.55537 14.8275 8.51958L11.0775 4.01958C11.007 3.93491 10.9187 3.86683 10.8189 3.82016C10.7191 3.7735 10.6102 3.7494 10.5 3.74958C10.3248 3.74923 10.1549 3.81026 10.02 3.92207C9.94406 3.98504 9.88128 4.06236 9.83527 4.14962C9.78925 4.23688 9.76091 4.33236 9.75185 4.4306C9.74279 4.52883 9.7532 4.62788 9.78249 4.72209C9.81177 4.81629 9.85935 4.90379 9.9225 4.97957L12.645 8.24958L3.75 8.24957C3.55109 8.24957 3.36032 8.32859 3.21967 8.46924C3.07902 8.6099 3 8.80066 3 8.99957C3 9.19849 3.07902 9.38925 3.21967 9.5299C3.36032 9.67056 3.55109 9.74957 3.75 9.74957Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-up">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M16.21 16H7.79a1.76 1.76 0 0 1-1.59-1 2.1 2.1 0 0 1 .26-2.21l4.21-5.1a1.76 1.76 0 0 1 2.66 0l4.21 5.1A2.1 2.1 0 0 1 17.8 15a1.76 1.76 0 0 1-1.59 1z" />
      </g>
    </g>
  </svg>
);

export const ArrowUpFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-up">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M16.21 16H7.79a1.76 1.76 0 0 1-1.59-1 2.1 2.1 0 0 1 .26-2.21l4.21-5.1a1.76 1.76 0 0 1 2.66 0l4.21 5.1A2.1 2.1 0 0 1 17.8 15a1.76 1.76 0 0 1-1.59 1z" />
      </g>
    </g>
  </svg>
);

export const ArrowUpWithStem = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.35927 8.86634C4.65427 9.21968 5.17927 9.26801 5.53261 8.97301L9.16594 5.94551V15.833C9.16594 16.293 9.53927 16.6663 9.99927 16.6663C10.4593 16.6663 10.8326 16.293 10.8326 15.833V5.94551L14.4659 8.97301C14.8201 9.26801 15.3451 9.21968 15.6393 8.86634C15.9343 8.51301 15.8868 7.98717 15.5326 7.69301L10.5326 3.52634C10.4934 3.49301 10.4468 3.47717 10.4034 3.45217C10.3693 3.43217 10.3393 3.40884 10.3018 3.39384C10.2043 3.35551 10.1026 3.33301 9.99927 3.33301C9.89594 3.33301 9.79427 3.35551 9.69677 3.39384C9.65927 3.40884 9.62927 3.43217 9.59511 3.45217C9.55177 3.47717 9.50511 3.49301 9.46594 3.52634L4.46594 7.69301C4.11261 7.98717 4.06427 8.51301 4.35927 8.86634Z" />
    <mask maskUnits="userSpaceOnUse" x="4" y="3" width="12" height="14">
      <path d="M4.35927 8.86634C4.65427 9.21968 5.17927 9.26801 5.53261 8.97301L9.16594 5.94551V15.833C9.16594 16.293 9.53927 16.6663 9.99927 16.6663C10.4593 16.6663 10.8326 16.293 10.8326 15.833V5.94551L14.4659 8.97301C14.8201 9.26801 15.3451 9.21968 15.6393 8.86634C15.9343 8.51301 15.8868 7.98717 15.5326 7.69301L10.5326 3.52634C10.4934 3.49301 10.4468 3.47717 10.4034 3.45217C10.3693 3.43217 10.3393 3.40884 10.3018 3.39384C10.2043 3.35551 10.1026 3.33301 9.99927 3.33301C9.89594 3.33301 9.79427 3.35551 9.69677 3.39384C9.65927 3.40884 9.62927 3.43217 9.59511 3.45217C9.55177 3.47717 9.50511 3.49301 9.46594 3.52634L4.46594 7.69301C4.11261 7.98717 4.06427 8.51301 4.35927 8.86634Z" />
    </mask>
  </svg>
);

export const ArrowIosUpwardOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-upward">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M18 15a1 1 0 0 1-.64-.23L12 10.29l-5.37 4.32a1 1 0 0 1-1.41-.15 1 1 0 0 1 .15-1.41l6-4.83a1 1 0 0 1 1.27 0l6 5a1 1 0 0 1 .13 1.41A1 1 0 0 1 18 15z" />
      </g>
    </g>
  </svg>
);

export const ArrowIosForwardOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-forward">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M10 19a1 1 0 0 1-.64-.23 1 1 0 0 1-.13-1.41L13.71 12 9.39 6.63a1 1 0 0 1 .15-1.41 1 1 0 0 1 1.46.15l4.83 6a1 1 0 0 1 0 1.27l-5 6A1 1 0 0 1 10 19z" />
      </g>
    </g>
  </svg>
);

export const ArrowheadRightOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrowhead-right">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M18.78 11.37l-4.78-6a1 1 0 0 0-1.41-.15 1 1 0 0 0-.15 1.41L16.71 12l-4.48 5.37a1 1 0 0 0 .13 1.41A1 1 0 0 0 13 19a1 1 0 0 0 .77-.36l5-6a1 1 0 0 0 .01-1.27z" />
        <path d="M7 5.37a1 1 0 0 0-1.61 1.26L9.71 12l-4.48 5.36a1 1 0 0 0 .13 1.41A1 1 0 0 0 6 19a1 1 0 0 0 .77-.36l5-6a1 1 0 0 0 0-1.27z" />
      </g>
    </g>
  </svg>
);

export const ArrowMix = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.78812 11.4707H16.2141C16.8871 11.4707 17.4941 11.0688 17.7991 10.4218C18.1451 9.68875 18.0441 8.82175 17.5401 8.21075L13.3271 3.11275C12.6561 2.29575 11.3471 2.29575 10.6751 3.11275L6.46112 8.21175C5.95812 8.82175 5.85812 9.68875 6.20312 10.4218C6.50812 11.0688 7.11612 11.4707 7.78812 11.4707ZM15.9101 9.47075H8.01512L11.9991 4.64875L15.9101 9.47075Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6751 20.858C11.0111 21.267 11.4951 21.5 12.0011 21.5C12.5071 21.5 12.9911 21.267 13.3271 20.858L17.5411 15.759C18.0441 15.149 18.1451 14.282 17.7991 13.549C17.4941 12.902 16.8871 12.5 16.2141 12.5H7.78806C7.11506 12.5 6.50806 12.902 6.20306 13.549C5.85806 14.282 5.95806 15.149 6.46206 15.76L10.6751 20.858ZM12.0031 19.322L8.09306 14.5H15.9881L12.0031 19.322Z"
    />
  </svg>
);

export const ArrowUpDown = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.26532 0.250732C4.27852 0.250997 4.29171 0.25124 4.30488 0.252197C4.31815 0.25316 4.33135 0.254215 4.34443 0.255859C4.35326 0.256972 4.36199 0.258826 4.37079 0.260254C4.38486 0.262535 4.39875 0.265258 4.41254 0.268311C4.42087 0.27015 4.42917 0.272043 4.43744 0.27417C4.4879 0.28717 4.53597 0.305717 4.58173 0.328369C4.6532 0.363681 4.7207 0.410213 4.78022 0.469727L7.78022 3.46973C8.07307 3.76261 8.07307 4.23739 7.78022 4.53027C7.48733 4.82316 7.01257 4.82314 6.71967 4.53027L4.99994 2.81055V13C4.99994 13.4142 4.66413 13.75 4.24994 13.75C3.83573 13.75 3.49994 13.4142 3.49994 13V2.81055L1.78022 4.53027C1.48733 4.82316 1.01257 4.82314 0.71967 4.53027C0.426777 4.23738 0.426777 3.76262 0.71967 3.46973L3.71967 0.469727C3.76255 0.426853 3.81103 0.389923 3.86322 0.358398C3.87818 0.349363 3.89321 0.340661 3.90863 0.332764C3.95539 0.308804 4.00478 0.289423 4.05658 0.275635C4.06901 0.272324 4.08138 0.268775 4.09394 0.266113C4.10216 0.264374 4.11052 0.263186 4.11884 0.261719C4.13198 0.259392 4.14517 0.257482 4.15839 0.255859C4.17172 0.254238 4.18514 0.25311 4.19867 0.252197C4.21063 0.251378 4.22259 0.250981 4.23456 0.250732C4.23966 0.25063 4.24482 0.25 4.24994 0.25C4.25509 0.25 4.26021 0.250629 4.26532 0.250732Z" />
    <path d="M11.7499 0.25C12.1641 0.250031 12.4999 0.585805 12.4999 1V11.1895L14.2197 9.46973C14.5126 9.17686 14.9873 9.17684 15.2802 9.46973C15.5731 9.76261 15.5731 10.2374 15.2802 10.5303L12.2802 13.5303C12.2453 13.5652 12.2064 13.5958 12.1652 13.6233C12.1359 13.6429 12.1057 13.6603 12.0744 13.6753C12.0403 13.6917 12.005 13.7059 11.9682 13.717C11.9557 13.7209 11.9428 13.7234 11.9301 13.7266C11.9184 13.7295 11.9069 13.733 11.895 13.7354C11.8896 13.7364 11.8842 13.7366 11.8788 13.7375C11.8369 13.7448 11.794 13.75 11.7499 13.75L11.673 13.7463C11.6569 13.7447 11.6412 13.7409 11.6254 13.7383C11.6176 13.737 11.6098 13.7362 11.602 13.7346C11.5934 13.7329 11.5849 13.7308 11.5764 13.7288C11.5609 13.7251 11.5454 13.7217 11.5302 13.717C11.4937 13.7059 11.4586 13.6916 11.4247 13.6753C11.3949 13.6609 11.3657 13.6448 11.3376 13.6262C11.2951 13.5982 11.2555 13.5661 11.2197 13.5303L8.21967 10.5303C7.92678 10.2374 7.92678 9.76262 8.21967 9.46973C8.51257 9.17686 8.98733 9.17684 9.28022 9.46973L10.9999 11.1895V1C10.9999 0.585786 11.3357 0.25 11.7499 0.25Z" />
  </svg>
);

export const AlertTriangleOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-triangle">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M22.56 16.3L14.89 3.58a3.43 3.43 0 0 0-5.78 0L1.44 16.3a3 3 0 0 0-.05 3A3.37 3.37 0 0 0 4.33 21h15.34a3.37 3.37 0 0 0 2.94-1.66 3 3 0 0 0-.05-3.04zm-1.7 2.05a1.31 1.31 0 0 1-1.19.65H4.33a1.31 1.31 0 0 1-1.19-.65 1 1 0 0 1 0-1l7.68-12.73a1.48 1.48 0 0 1 2.36 0l7.67 12.72a1 1 0 0 1 .01 1.01z" />
        <circle cx="12" cy="16" r="1" />
        <path d="M12 8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const AlertTriangleFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-triangle">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M22.56 16.3L14.89 3.58a3.43 3.43 0 0 0-5.78 0L1.44 16.3a3 3 0 0 0-.05 3A3.37 3.37 0 0 0 4.33 21h15.34a3.37 3.37 0 0 0 2.94-1.66 3 3 0 0 0-.05-3.04zM12 17a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm1-4a1 1 0 0 1-2 0V9a1 1 0 0 1 2 0z" />
      </g>
    </g>
  </svg>
);

export const AlertCircleOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <circle cx="12" cy="16" r="1" />
        <path d="M12 7a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const AlertCircleFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="alert-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 15a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm1-4a1 1 0 0 1-2 0V8a1 1 0 0 1 2 0z" />
      </g>
    </g>
  </svg>
);

//B

export const BarChartOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="bar-chart">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M12 4a1 1 0 0 0-1 1v15a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1z" />
        <path d="M19 12a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0v-7a1 1 0 0 0-1-1z" />
        <path d="M5 8a1 1 0 0 0-1 1v11a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const BlockJSON = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 18.4999C21.5523 18.4999 22 18.9477 22 19.4999C22 20.0522 21.5523 20.4999 21 20.4999H3C2.44772 20.4999 2 20.0522 2 19.4999C2 18.9477 2.44772 18.4999 3 18.4999H21Z"
      fill="currentColor"
    />
    <path
      d="M5 3.49994C5.55228 3.49994 5.99999 3.94766 6 4.49994C6 5.05222 5.55228 5.49994 5 5.49994V7.49994C5 7.85448 4.90393 8.19822 4.72949 8.49994C4.90393 8.80165 5 9.1454 5 9.49994V11.4999C5.55228 11.4999 5.99999 11.9477 6 12.4999C6 13.0522 5.55228 13.4999 5 13.4999C4.46957 13.4999 3.96101 13.2891 3.58594 12.914C3.21087 12.5389 3 12.0304 3 11.4999V9.49994C2.44772 9.49994 2 9.05222 2 8.49994C2.00001 7.94766 2.44772 7.49994 3 7.49994V5.49994C3.00001 4.96951 3.21087 4.46094 3.58594 4.08588C3.96101 3.71081 4.46957 3.49994 5 3.49994Z"
      fill="currentColor"
    />
    <path
      d="M9 3.49994C9.53043 3.49994 10.039 3.71081 10.4141 4.08588C10.7891 4.46094 11 4.96951 11 5.49994V7.49994C11.5523 7.49994 12 7.94766 12 8.49994C12 9.05222 11.5523 9.49994 11 9.49994V11.4999C11 12.0304 10.7891 12.5389 10.4141 12.914C10.039 13.2891 9.53043 13.4999 9 13.4999C8.44772 13.4999 8 13.0522 8 12.4999C8.00001 11.9477 8.44772 11.4999 9 11.4999V9.49994C9 9.14556 9.09525 8.80155 9.26953 8.49994C9.09525 8.19833 9 7.85432 9 7.49994V5.49994C8.44772 5.49994 8 5.05222 8 4.49994C8.00001 3.94766 8.44772 3.49994 9 3.49994Z"
      fill="currentColor"
    />
    <path
      d="M21 11.4999C21.5523 11.4999 22 11.9477 22 12.4999C22 13.0522 21.5523 13.4999 21 13.4999H15C14.4477 13.4999 14 13.0522 14 12.4999C14 11.9477 14.4477 11.4999 15 11.4999H21Z"
      fill="currentColor"
    />
    <path
      d="M21 4.49994C21.5523 4.49994 22 4.94765 22 5.49994C22 6.05222 21.5523 6.49994 21 6.49994H15C14.4477 6.49994 14 6.05222 14 5.49994C14 4.94765 14.4477 4.49994 15 4.49994H21Z"
      fill="currentColor"
    />
  </svg>
);

export const BlockString = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 18.4999C21.5523 18.4999 22 18.9477 22 19.4999C22 20.0522 21.5523 20.4999 21 20.4999H3C2.44772 20.4999 2 20.0522 2 19.4999C2 18.9477 2.44772 18.4999 3 18.4999H21Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 3.49994C7.20885 3.49994 7.41472 3.54334 7.60449 3.62689L7.78809 3.72357L7.95703 3.84467C8.11657 3.97683 8.24732 4.14151 8.34082 4.32806C8.3458 4.33799 8.35083 4.34825 8.35547 4.35834L11.9082 12.082C12.139 12.5837 11.9196 13.1773 11.418 13.4081C10.9163 13.6389 10.3227 13.4195 10.0918 12.9179L9.43945 11.4999H4.56055L3.9082 12.9179C3.67734 13.4195 3.08371 13.6389 2.58203 13.4081C2.0804 13.1773 1.86102 12.5837 2.0918 12.082L2.99512 10.1171C2.99897 10.1078 3.00369 10.0989 3.00781 10.0898L5.64453 4.35834L5.65918 4.32806C5.78388 4.07927 5.97512 3.86978 6.21191 3.72357L6.39551 3.62689C6.58528 3.54334 6.79115 3.49994 7 3.49994ZM5.48047 9.49994H8.51953L7 6.19818L5.48047 9.49994Z"
      fill="currentColor"
    />
    <path
      d="M21 11.4999C21.5523 11.4999 22 11.9477 22 12.4999C22 13.0522 21.5523 13.4999 21 13.4999H15C14.4477 13.4999 14 13.0522 14 12.4999C14 11.9477 14.4477 11.4999 15 11.4999H21Z"
      fill="currentColor"
    />
    <path
      d="M21 4.49994C21.5523 4.49994 22 4.94765 22 5.49994C22 6.05222 21.5523 6.49994 21 6.49994H15C14.4477 6.49994 14 6.05222 14 5.49994C14 4.94765 14.4477 4.49994 15 4.49994H21Z"
      fill="currentColor"
    />
  </svg>
);

export const BookFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="book">
        <rect width="24" height="24" opacity="0" />
        <path d="M19 3H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM7 19a1 1 0 0 1 0-2h11v2z" />
      </g>
    </g>
  </svg>
);

export const BookOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="book">
        <rect width="24" height="24" opacity="0" />
        <path d="M19 3H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM7 5h11v10H7a3 3 0 0 0-1 .18V6a1 1 0 0 1 1-1zm0 14a1 1 0 0 1 0-2h11v2z" />
      </g>
    </g>
  </svg>
);

export const Brain = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0023 4.86518C16.0023 4.86518 15.4313 3.68471 14.2891 3.09468C13.1469 2.50465 12.0047 4.86529 12.0047 4.86529C12.0047 7.74512 12.0274 10.0746 12.0644 11.9481M16.0023 4.86518C16.0023 4.86518 16.5734 4.86524 17.1445 5.45547C17.7156 6.04571 17.1445 7.22612 17.1445 7.22612M16.0023 4.86518C16.0023 4.86518 15.3062 5.22495 14.8602 5.45547M17.1445 7.22612C17.1445 7.22612 17.7156 7.22618 18.2867 7.81641C18.8578 8.40665 18.8578 9.58711 18.8578 9.58711C18.8578 9.58711 20 10.1773 20 11.3578C20 12.5383 18.8578 13.7188 18.8578 13.7188M17.1445 7.22612C17.1445 7.22612 17.1445 7.40977 16.0023 8C14.8602 8.59023 15 8.5 15 8.5M18.8578 13.7188C18.8578 13.7188 20 13.7188 19.4289 15.4895C19.4195 15.5139 19.4096 15.5378 19.3995 15.5612C19.0759 16.3057 18.4368 18.0679 17.7156 18.4406V18.4406C16.5734 19.0309 15.567 17.5589 15.4313 18.4406C15.3533 18.9468 16.6481 19.1756 16.0023 19.6211C15.2629 20.1313 13.1855 20.2912 12.5758 19.0309M18.8578 13.7188H17.7156C17.7156 13.7188 16.7108 13.5902 16 13M15 15.5C15 15.5 13.8916 15.3449 13.1469 16.0797C12.5567 16.662 12.0708 17.9871 12.5758 19.0309M12.5758 19.0309C12.0047 17.8504 12.133 21.3915 12.0047 17.8504C11.9765 17.0725 12.0851 12.9938 12.0644 11.9481M12.0644 11.9481L12.0475 11L14 11.5"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M7.99765 4.86518C7.99765 4.86518 8.56874 3.68471 9.71093 3.09468C10.8531 2.50465 11.9953 4.86529 11.9953 4.86529C11.9953 7.74512 11.9726 10.0746 11.9356 11.9481M7.99765 4.86518C7.99765 4.86518 7.42656 4.86524 6.85546 5.45547C6.28437 6.04571 6.85546 7.22612 6.85546 7.22612M7.99765 4.86518C7.99765 4.86518 8.69378 5.22495 9.13984 5.45547M6.85546 7.22612C6.85546 7.22612 6.28437 7.22618 5.71328 7.81641C5.14219 8.40665 5.14219 9.58711 5.14219 9.58711C5.14219 9.58711 4 10.1773 4 11.3578C4 12.5383 5.14219 13.7188 5.14219 13.7188M6.85546 7.22612C6.85546 7.22612 6.85546 7.40977 7.99765 8C9.13984 8.59023 9 8.5 9 8.5M5.14219 13.7188C5.14219 13.7188 4 13.7188 4.57109 15.4895C4.58054 15.5139 4.59035 15.5378 4.60052 15.5612C4.92408 16.3057 5.56317 18.0679 6.28437 18.4406V18.4406C7.42656 19.0309 8.43303 17.5589 8.56874 18.4406C8.64665 18.9468 7.35191 19.1756 7.99765 19.6211C8.73709 20.1313 10.8145 20.2912 11.4242 19.0309M5.14219 13.7188H6.28437C6.28437 13.7188 7.28917 13.5902 8 13M9 15.5C9 15.5 10.1084 15.3449 10.8531 16.0797C11.4433 16.662 11.9292 17.9871 11.4242 19.0309M11.4242 19.0309C11.9953 17.8504 11.867 21.3915 11.9953 17.8504C12.0235 17.0725 11.9149 12.9938 11.9356 11.9481M11.9356 11.9481L11.9525 11L10 11.5"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

export const BrowserOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="browser">
        <rect width="24" height="24" opacity="0" />
        <path d="M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7h14zM5 9V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3z" />
        <circle cx="8" cy="7.03" r="1" />
        <circle cx="12" cy="7.03" r="1" />
      </g>
    </g>
  </svg>
);

export const BulbOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="bulb">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 7a5 5 0 0 0-3 9v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a5 5 0 0 0-3-9zm1.5 7.59a1 1 0 0 0-.5.87V20h-2v-4.54a1 1 0 0 0-.5-.87A3 3 0 0 1 9 12a3 3 0 0 1 6 0 3 3 0 0 1-1.5 2.59z" />
        <path d="M12 6a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1z" />
        <path d="M21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" />
        <path d="M5 11H3a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" />
        <path d="M7.66 6.42L6.22 5a1 1 0 0 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0-.06-1.41z" />
        <path d="M19.19 5.05a1 1 0 0 0-1.41 0l-1.44 1.37a1 1 0 0 0 0 1.41 1 1 0 0 0 .72.31 1 1 0 0 0 .69-.28l1.44-1.39a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

//C
export const CalendarOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="calendar">
        <rect width="24" height="24" opacity="0" />
        <path d="M18 4h-1V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM6 6h1v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h1a1 1 0 0 1 1 1v4H5V7a1 1 0 0 1 1-1zm12 14H6a1 1 0 0 1-1-1v-6h14v6a1 1 0 0 1-1 1z" />
        <circle cx="8" cy="16" r="1" />
        <path d="M16 15h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const ChevronUpDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 18 18"
    width="24"
  >
    <path
      className="fill"
      d="M14,5.99a1,1,0,0,1-1.7055.7055L9.006,3.409,5.717,6.695A1,1,0,0,1,4.28,5.3085l.0245-.0245L8.3,1.2925a1,1,0,0,1,1.4125,0L13.707,5.284A.99446.99446,0,0,1,14,5.99Z"
    />
    <path
      className="fill"
      d="M4,12.01a1,1,0,0,1,1.7055-.7055l3.289,3.286,3.289-3.286a1,1,0,0,1,1.437,1.3865l-.0245.0245L9.7,16.707a1,1,0,0,1-1.4125,0L4.293,12.7155A.99452.99452,0,0,1,4,12.01Z"
    />
  </svg>
);

export const Column = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.2 12.4H9.8C10.0889 12.4 10.375 12.3431 10.6419 12.2325C10.9088 12.122 11.1513 11.9599 11.3556 11.7556C11.5599 11.5513 11.722 11.3088 11.8325 11.0419C11.9431 10.775 12 10.4889 12 10.2V2.2C12 1.91109 11.9431 1.62501 11.8325 1.3581C11.722 1.09118 11.5599 0.848654 11.3556 0.644365C11.1513 0.440076 10.9088 0.278026 10.6419 0.167465C10.375 0.0569049 10.0889 0 9.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V10.2C0 10.7835 0.231785 11.3431 0.644365 11.7556C1.05694 12.1682 1.61652 12.4 2.2 12.4ZM4.8 11.2V1.2H7.2V11.2H4.8ZM10.8 2.2V10.2C10.8 10.4652 10.6946 10.7196 10.5071 10.9071C10.3196 11.0946 10.0652 11.2 9.8 11.2H8.4V1.2H9.8C10.0652 1.2 10.3196 1.30536 10.5071 1.49289C10.6946 1.68043 10.8 1.93478 10.8 2.2ZM1.2 2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H3.6V11.2H2.2C1.93478 11.2 1.68043 11.0946 1.49289 10.9071C1.30536 10.7196 1.2 10.4652 1.2 10.2V2.2Z" />
  </svg>
);

export const CornerUpRightOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="corner-up-right">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M19.78 10.38l-4-5a1 1 0 0 0-1.56 1.24l2.7 3.38H8a3 3 0 0 0-3 3v5a1 1 0 0 0 2 0v-5a1 1 0 0 1 1-1h8.92l-2.7 3.38a1 1 0 0 0 .16 1.4A1 1 0 0 0 15 17a1 1 0 0 0 .78-.38l4-5a1 1 0 0 0 0-1.24z" />
      </g>
    </g>
  </svg>
);

export const Commit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-git-commit"
  >
    <circle cx="12" cy="12" r="4" fill="none"></circle>
    <line x1="1.05" y1="12" x2="7" y2="12"></line>
    <line x1="17.01" y1="12" x2="22.96" y2="12"></line>
  </svg>
);

export const Code = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="code">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M8.64 5.23a1 1 0 0 0-1.41.13l-5 6a1 1 0 0 0 0 1.27l4.83 6a1 1 0 0 0 .78.37 1 1 0 0 0 .78-1.63L4.29 12l4.48-5.36a1 1 0 0 0-.13-1.41z" />
        <path d="M21.78 11.37l-4.78-6a1 1 0 0 0-1.41-.15 1 1 0 0 0-.15 1.41L19.71 12l-4.48 5.37a1 1 0 0 0 .13 1.41A1 1 0 0 0 16 19a1 1 0 0 0 .77-.36l5-6a1 1 0 0 0 .01-1.27z" />
      </g>
    </g>
  </svg>
);

export const CodeDownload = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7793 11.373L16.9513 5.373C16.6033 4.943 15.9743 4.873 15.5453 5.221C15.1143 5.567 15.0473 6.196 15.3923 6.627L19.7083 11.989L15.2313 17.359C14.8783 17.784 14.9353 18.415 15.3593 18.769C15.5473 18.924 15.7733 19 15.9993 19C16.2863 19 16.5703 18.878 16.7683 18.641L21.7683 12.641C22.0733 12.274 22.0783 11.744 21.7793 11.373ZM4.29198 12.0107L8.76898 6.6407C9.12198 6.2157 9.06398 5.5847 8.64098 5.2317C8.21498 4.8787 7.58598 4.9357 7.23098 5.3597L2.23098 11.3597C1.92698 11.7257 1.92198 12.2557 2.22098 12.6267L7.04898 18.6267C7.24698 18.8717 7.53598 18.9997 7.82898 18.9997C8.04898 18.9997 8.27098 18.9277 8.45498 18.7797C8.88598 18.4327 8.95298 17.8037 8.60698 17.3727L4.29198 12.0107ZM14.3057 11.3842C14.7017 11.0002 15.3367 11.0132 15.7197 11.4092C16.1027 11.8062 16.0917 12.4392 15.6947 12.8232L12.6947 15.7202C12.5007 15.9062 12.2497 16.0002 11.9997 16.0002C11.7437 16.0002 11.4887 15.9022 11.2927 15.7072L8.29268 12.7072C7.90268 12.3162 7.90268 11.6832 8.29268 11.2932C8.68368 10.9022 9.31668 10.9022 9.70668 11.2932L10.9997 12.5852V8.0002C10.9997 7.4472 11.4477 7.0002 11.9997 7.0002C12.5527 7.0002 12.9997 7.4472 12.9997 8.0002V12.6442L14.3057 11.3842Z"
        />
        <mask
          id="mask0_0_1632"
          style={{
            maskType: "alpha",
          }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="4"
          width="22"
          height="15"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.7793 11.373L16.9513 5.373C16.6033 4.943 15.9743 4.873 15.5453 5.221C15.1143 5.567 15.0473 6.196 15.3923 6.627L19.7083 11.989L15.2313 17.359C14.8783 17.784 14.9353 18.415 15.3593 18.769C15.5473 18.924 15.7733 19 15.9993 19C16.2863 19 16.5703 18.878 16.7683 18.641L21.7683 12.641C22.0733 12.274 22.0783 11.744 21.7793 11.373ZM4.29198 12.0107L8.76898 6.6407C9.12198 6.2157 9.06398 5.5847 8.64098 5.2317C8.21498 4.8787 7.58598 4.9357 7.23098 5.3597L2.23098 11.3597C1.92698 11.7257 1.92198 12.2557 2.22098 12.6267L7.04898 18.6267C7.24698 18.8717 7.53598 18.9997 7.82898 18.9997C8.04898 18.9997 8.27098 18.9277 8.45498 18.7797C8.88598 18.4327 8.95298 17.8037 8.60698 17.3727L4.29198 12.0107ZM14.3057 11.3842C14.7017 11.0002 15.3367 11.0132 15.7197 11.4092C16.1027 11.8062 16.0917 12.4392 15.6947 12.8232L12.6947 15.7202C12.5007 15.9062 12.2497 16.0002 11.9997 16.0002C11.7437 16.0002 11.4887 15.9022 11.2927 15.7072L8.29268 12.7072C7.90268 12.3162 7.90268 11.6832 8.29268 11.2932C8.68368 10.9022 9.31668 10.9022 9.70668 11.2932L10.9997 12.5852V8.0002C10.9997 7.4472 11.4477 7.0002 11.9997 7.0002C12.5527 7.0002 12.9997 7.4472 12.9997 8.0002V12.6442L14.3057 11.3842Z"
          />
        </mask>
        <g mask="url(#mask0_0_1632)"></g>
      </g>
    </svg>
  );
};

export const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-left">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M13.36 17a1 1 0 0 1-.72-.31l-3.86-4a1 1 0 0 1 0-1.4l4-4a1 1 0 1 1 1.42 1.42L10.9 12l3.18 3.3a1 1 0 0 1 0 1.41 1 1 0 0 1-.72.29z" />
      </g>
    </g>
  </svg>
);

export const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-right">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M10.5 17a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42L13.1 12 9.92 8.69a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l3.86 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-.7.32z" />
      </g>
    </g>
  </svg>
);

export const ChevronRightOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-right">
        <rect
          width="24"
          height="24"
          transform="rotate(-90 12 12)"
          opacity="0"
        />
        <path d="M10.5 17a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42L13.1 12 9.92 8.69a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l3.86 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-.7.32z" />
      </g>
    </g>
  </svg>
);

export const ChevronUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-up">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M16 14.5a1 1 0 0 1-.71-.29L12 10.9l-3.3 3.18a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.42l4-3.86a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1 0 1.42 1 1 0 0 1-.69.28z" />
      </g>
    </g>
  </svg>
);

export const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-down">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28z" />
      </g>
    </g>
  </svg>
);

export const ChevronDownOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="chevron-down">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28z" />
      </g>
    </g>
  </svg>
);

export const Cube = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="cube">
        <rect width="24" height="24" opacity="0" />
        <path d="M11.25 11.83L3 8.36v7.73a1.69 1.69 0 0 0 1 1.52L11.19 21h.06z" />
        <path d="M12 10.5l8.51-3.57a1.62 1.62 0 0 0-.51-.38l-7.2-3.37a1.87 1.87 0 0 0-1.6 0L4 6.55a1.62 1.62 0 0 0-.51.38z" />
        <path d="M12.75 11.83V21h.05l7.2-3.39a1.69 1.69 0 0 0 1-1.51V8.36z" />
      </g>
    </g>
  </svg>
);

export const CubeOutline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="cube">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.654 7.24778C20.6545 7.25157 20.655 7.25534 20.6564 7.25891C20.8684 7.62191 20.9994 8.02891 21.0004 8.45691V15.5399C20.9994 16.4879 20.4224 17.3659 19.5304 17.7779L13.1334 20.7499C12.7724 20.9179 12.3844 21.0019 11.9964 21.0019C11.6074 21.0019 11.2194 20.9179 10.8574 20.7489L4.45839 17.7769C3.56439 17.3589 2.99239 16.4749 3.00039 15.5249V8.45791C3.00039 8.02991 3.13139 7.62291 3.34239 7.26091C3.34439 7.25641 3.34514 7.25191 3.34589 7.24741C3.34664 7.24291 3.34739 7.23841 3.34939 7.23391C3.35141 7.22986 3.35446 7.22633 3.35763 7.22266C3.36072 7.21907 3.36392 7.21536 3.36639 7.21091C3.40377 7.14975 3.44764 7.09363 3.49188 7.03705C3.49972 7.02703 3.50756 7.017 3.51539 7.00691C3.52685 6.99407 3.53758 6.98061 3.54827 6.96723C3.56835 6.94207 3.58824 6.91715 3.61239 6.89691C3.84739 6.62091 4.12539 6.37891 4.46939 6.21991L10.8664 3.24791C11.5874 2.91591 12.4124 2.91491 13.1314 3.24691C13.1314 3.24791 13.1324 3.24791 13.1334 3.24791L19.5334 6.22091C19.8774 6.37991 20.1544 6.62291 20.3894 6.89891C20.4111 6.91742 20.4291 6.93959 20.4474 6.96205C20.4577 6.97478 20.4682 6.98761 20.4794 6.99991C20.492 7.01663 20.5049 7.03318 20.5177 7.04972C20.5586 7.10243 20.5994 7.15507 20.6344 7.21291C20.6365 7.21633 20.6392 7.21919 20.6418 7.22198C20.6453 7.22572 20.6487 7.22933 20.6504 7.23391C20.6526 7.23834 20.6533 7.24308 20.654 7.24778ZM11.7074 5.06391C11.7984 5.02091 11.8994 4.99991 12.0004 4.99991C12.1004 4.99991 12.2014 5.02091 12.2924 5.06391L17.6214 7.53791L12.0004 10.1499L6.37839 7.53791L11.7074 5.06391ZM5.00039 15.5319C4.99839 15.7139 5.11439 15.8759 5.30339 15.9639L11.0004 18.6089V11.8909L5.00039 9.10391V15.5319ZM13.0004 18.6069L18.6904 15.9629C18.8824 15.8749 19.0004 15.7129 19.0004 15.5389V9.10391L13.0004 11.8909V18.6069Z"
        />
        <mask
          id="mask0_0_196"
          mask="alpha"
          maskUnits="userSpaceOnUse"
          x="3"
          y="2"
          width="19"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.654 7.24778C20.6545 7.25157 20.655 7.25534 20.6564 7.25891C20.8684 7.62191 20.9994 8.02891 21.0004 8.45691V15.5399C20.9994 16.4879 20.4224 17.3659 19.5304 17.7779L13.1334 20.7499C12.7724 20.9179 12.3844 21.0019 11.9964 21.0019C11.6074 21.0019 11.2194 20.9179 10.8574 20.7489L4.45839 17.7769C3.56439 17.3589 2.99239 16.4749 3.00039 15.5249V8.45791C3.00039 8.02991 3.13139 7.62291 3.34239 7.26091C3.34439 7.25641 3.34514 7.25191 3.34589 7.24741C3.34664 7.24291 3.34739 7.23841 3.34939 7.23391C3.35141 7.22986 3.35446 7.22633 3.35763 7.22266C3.36072 7.21907 3.36392 7.21536 3.36639 7.21091C3.40377 7.14975 3.44764 7.09363 3.49188 7.03705C3.49972 7.02703 3.50756 7.017 3.51539 7.00691C3.52685 6.99407 3.53758 6.98061 3.54827 6.96723C3.56835 6.94207 3.58824 6.91715 3.61239 6.89691C3.84739 6.62091 4.12539 6.37891 4.46939 6.21991L10.8664 3.24791C11.5874 2.91591 12.4124 2.91491 13.1314 3.24691C13.1314 3.24791 13.1324 3.24791 13.1334 3.24791L19.5334 6.22091C19.8774 6.37991 20.1544 6.62291 20.3894 6.89891C20.4111 6.91742 20.4291 6.93959 20.4474 6.96205C20.4577 6.97478 20.4682 6.98761 20.4794 6.99991C20.492 7.01663 20.5049 7.03318 20.5177 7.04972C20.5586 7.10243 20.5994 7.15507 20.6344 7.21291C20.6365 7.21633 20.6392 7.21919 20.6418 7.22198C20.6453 7.22572 20.6487 7.22933 20.6504 7.23391C20.6526 7.23834 20.6533 7.24308 20.654 7.24778ZM11.7074 5.06391C11.7984 5.02091 11.8994 4.99991 12.0004 4.99991C12.1004 4.99991 12.2014 5.02091 12.2924 5.06391L17.6214 7.53791L12.0004 10.1499L6.37839 7.53791L11.7074 5.06391ZM5.00039 15.5319C4.99839 15.7139 5.11439 15.8759 5.30339 15.9639L11.0004 18.6089V11.8909L5.00039 9.10391V15.5319ZM13.0004 18.6069L18.6904 15.9629C18.8824 15.8749 19.0004 15.7129 19.0004 15.5389V9.10391L13.0004 11.8909V18.6069Z"
          />
        </mask>
        <g mask="url(#mask0_0_196)"></g>
      </g>
    </svg>
  );
};

export const ClockOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="clock">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M16 11h-3V8a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const Checkmark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="checkmark">
        <rect width="24" height="24" opacity="0" />
        <path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z" />
      </g>
    </g>
  </svg>
);

export const CheckmarkCircle = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.339 22.0001 6.836 20.9681 4.949 19.0911C3.055 17.2081 2.008 14.7001 2 12.0291C1.992 9.3571 3.025 6.8431 4.909 4.9491C6.792 3.0551 9.3 2.0081 11.971 2.0001C12.766 2.0121 13.576 2.0921 14.352 2.2781C14.888 2.4081 15.219 2.9481 15.089 3.4851C14.96 4.0211 14.417 4.3511 13.883 4.2231C13.262 4.0731 12.603 4.0101 11.977 4.0001C9.84 4.0061 7.833 4.8441 6.327 6.3591C4.82 7.8741 3.994 9.8861 4 12.0231C4.006 14.1601 4.844 16.1661 6.359 17.6731C7.869 19.1741 9.871 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.293 11.293C8.684 10.902 9.316 10.902 9.707 11.293L11.951 13.537L18.248 6.341C18.612 5.928 19.243 5.884 19.659 6.248C20.074 6.611 20.116 7.243 19.752 7.659L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.293 12.707C7.902 12.316 7.902 11.684 8.293 11.293Z"
      />
      <mask
        mask="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.339 22.0001 6.836 20.9681 4.949 19.0911C3.055 17.2081 2.008 14.7001 2 12.0291C1.992 9.3571 3.025 6.8431 4.909 4.9491C6.792 3.0551 9.3 2.0081 11.971 2.0001C12.766 2.0121 13.576 2.0921 14.352 2.2781C14.888 2.4081 15.219 2.9481 15.089 3.4851C14.96 4.0211 14.417 4.3511 13.883 4.2231C13.262 4.0731 12.603 4.0101 11.977 4.0001C9.84 4.0061 7.833 4.8441 6.327 6.3591C4.82 7.8741 3.994 9.8861 4 12.0231C4.006 14.1601 4.844 16.1661 6.359 17.6731C7.869 19.1741 9.871 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.293 11.293C8.684 10.902 9.316 10.902 9.707 11.293L11.951 13.537L18.248 6.341C18.612 5.928 19.243 5.884 19.659 6.248C20.074 6.611 20.116 7.243 19.752 7.659L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.293 12.707C7.902 12.316 7.902 11.684 8.293 11.293Z"
        />
      </mask>
      <g mask="url(#mask0)"></g>
    </g>
  </svg>
);

export const CheckmarkOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="checkmark">
        <rect width="24" height="24" opacity="0" />
        <path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z" />
      </g>
    </g>
  </svg>
);

export const CheckmarkCircleOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.339 22.0001 6.836 20.9681 4.949 19.0911C3.055 17.2081 2.008 14.7001 2 12.0291C1.992 9.3571 3.025 6.8431 4.909 4.9491C6.792 3.0551 9.3 2.0081 11.971 2.0001C12.766 2.0121 13.576 2.0921 14.352 2.2781C14.888 2.4081 15.219 2.9481 15.089 3.4851C14.96 4.0211 14.417 4.3511 13.883 4.2231C13.262 4.0731 12.603 4.0101 11.977 4.0001C9.84 4.0061 7.833 4.8441 6.327 6.3591C4.82 7.8741 3.994 9.8861 4 12.0231C4.006 14.1601 4.844 16.1661 6.359 17.6731C7.869 19.1741 9.871 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.293 11.293C8.684 10.902 9.316 10.902 9.707 11.293L11.951 13.537L18.248 6.341C18.612 5.928 19.243 5.884 19.659 6.248C20.074 6.611 20.116 7.243 19.752 7.659L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.293 12.707C7.902 12.316 7.902 11.684 8.293 11.293Z"
      />
      <mask
        mask="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.339 22.0001 6.836 20.9681 4.949 19.0911C3.055 17.2081 2.008 14.7001 2 12.0291C1.992 9.3571 3.025 6.8431 4.909 4.9491C6.792 3.0551 9.3 2.0081 11.971 2.0001C12.766 2.0121 13.576 2.0921 14.352 2.2781C14.888 2.4081 15.219 2.9481 15.089 3.4851C14.96 4.0211 14.417 4.3511 13.883 4.2231C13.262 4.0731 12.603 4.0101 11.977 4.0001C9.84 4.0061 7.833 4.8441 6.327 6.3591C4.82 7.8741 3.994 9.8861 4 12.0231C4.006 14.1601 4.844 16.1661 6.359 17.6731C7.869 19.1741 9.871 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.293 11.293C8.684 10.902 9.316 10.902 9.707 11.293L11.951 13.537L18.248 6.341C18.612 5.928 19.243 5.884 19.659 6.248C20.074 6.611 20.116 7.243 19.752 7.659L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.293 12.707C7.902 12.316 7.902 11.684 8.293 11.293Z"
        />
      </mask>
      <g mask="url(#mask0)"></g>
    </g>
  </svg>
);

export const CheckmarkCircleFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="checkmark-circle-2">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm4.3 7.61l-4.57 6a1 1 0 0 1-.79.39 1 1 0 0 1-.79-.38l-2.44-3.11a1 1 0 0 1 1.58-1.23l1.63 2.08 3.78-5a1 1 0 1 1 1.6 1.22z" />
      </g>
    </g>
  </svg>
);

export const CloseCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="close-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm2.71 11.29a1 1 0 0 1 0 1.42 1 1 0 0 1-1.42 0L12 13.41l-1.29 1.3a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42l1.3-1.29-1.3-1.29a1 1 0 0 1 1.42-1.42l1.29 1.3 1.29-1.3a1 1 0 0 1 1.42 1.42L13.41 12z" />
      </g>
    </g>
  </svg>
);

export const CloseOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="close">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

export const CloseCircleOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="close-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M14.71 9.29a1 1 0 0 0-1.42 0L12 10.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l1.3 1.29-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.29-1.3 1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12l1.3-1.29a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

export const CollapseOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="collapse">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M19 9h-2.58l3.29-3.29a1 1 0 1 0-1.42-1.42L15 7.57V5a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2z" />
        <path d="M10 13H5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 16.42V19a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const CloudDownloadOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="cloud-download">
        <rect width="24" height="24" opacity="0" />
        <path d="M14.31 16.38L13 17.64V12a1 1 0 0 0-2 0v5.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l3 3A1 1 0 0 0 12 21a1 1 0 0 0 .69-.28l3-2.9a1 1 0 1 0-1.38-1.44z" />
        <path d="M17.67 7A6 6 0 0 0 6.33 7a5 5 0 0 0-3.08 8.27A1 1 0 1 0 4.75 14 3 3 0 0 1 7 9h.1a1 1 0 0 0 1-.8 4 4 0 0 1 7.84 0 1 1 0 0 0 1 .8H17a3 3 0 0 1 2.25 5 1 1 0 0 0 .09 1.42 1 1 0 0 0 .66.25 1 1 0 0 0 .75-.34A5 5 0 0 0 17.67 7z" />
      </g>
    </g>
  </svg>
);

export const CloudUpload = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="cloud-upload">
        <rect width="24" height="24" opacity="0" />
        <path d="M21.9 12c0-.11-.06-.22-.09-.33a4.17 4.17 0 0 0-.18-.57c-.05-.12-.12-.24-.18-.37s-.15-.3-.24-.44S21 10.08 21 10s-.2-.25-.31-.37-.21-.2-.32-.3L20 9l-.36-.24a3.68 3.68 0 0 0-.44-.23l-.39-.18a4.13 4.13 0 0 0-.5-.15 3 3 0 0 0-.41-.09L17.67 8A6 6 0 0 0 6.33 8l-.18.05a3 3 0 0 0-.41.09 4.13 4.13 0 0 0-.5.15l-.39.18a3.68 3.68 0 0 0-.44.23l-.36.3-.37.31c-.11.1-.22.19-.32.3s-.21.25-.31.37-.18.23-.26.36-.16.29-.24.44-.13.25-.18.37a4.17 4.17 0 0 0-.18.57c0 .11-.07.22-.09.33A5.23 5.23 0 0 0 2 13a5.5 5.5 0 0 0 .09.91c0 .1.05.19.07.29a5.58 5.58 0 0 0 .18.58l.12.29a5 5 0 0 0 .3.56l.14.22a.56.56 0 0 0 .05.08L3 16a5 5 0 0 0 4 2h3v-1.37a2 2 0 0 1-1 .27 2.05 2.05 0 0 1-1.44-.61 2 2 0 0 1 .05-2.83l3-2.9A2 2 0 0 1 12 10a2 2 0 0 1 1.41.59l3 3a2 2 0 0 1 0 2.82A2 2 0 0 1 15 17a1.92 1.92 0 0 1-1-.27V18h3a5 5 0 0 0 4-2l.05-.05a.56.56 0 0 0 .05-.08l.14-.22a5 5 0 0 0 .3-.56l.12-.29a5.58 5.58 0 0 0 .18-.58c0-.1.05-.19.07-.29A5.5 5.5 0 0 0 22 13a5.23 5.23 0 0 0-.1-1z" />
        <path d="M12.71 11.29a1 1 0 0 0-1.4 0l-3 2.9a1 1 0 1 0 1.38 1.44L11 14.36V20a1 1 0 0 0 2 0v-5.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

//D
export const DatabaseOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 8.66669C16.1421 8.66669 19.5 7.5474 19.5 6.16669C19.5 4.78598 16.1421 3.66669 12 3.66669C7.85786 3.66669 4.5 4.78598 4.5 6.16669C4.5 7.5474 7.85786 8.66669 12 8.66669Z"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 12C19.5 13.3833 16.1667 14.5 12 14.5C7.83333 14.5 4.5 13.3833 4.5 12"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 6.16669V17.8334C4.5 19.2167 7.83333 20.3334 12 20.3334C16.1667 20.3334 19.5 19.2167 19.5 17.8334V6.16669"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DragHandleOutline = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z" />
  </svg>
);

export const DollarSignOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.9074 21C11.3552 21 10.9074 20.5522 10.9074 20V18.85C10.0241 18.65 9.2616 18.2666 8.61994 17.7C8.16615 17.2992 7.79781 16.7818 7.5149 16.1476C7.30605 15.6795 7.57198 15.1522 8.04705 14.9596C8.58891 14.7399 9.19159 15.0401 9.48652 15.545C9.67997 15.8761 9.90778 16.1528 10.1699 16.375C10.6616 16.7916 11.3074 17 12.1074 17C12.7908 17 13.3699 16.8458 13.8449 16.5375C14.3199 16.2291 14.5574 15.75 14.5574 15.1C14.5574 14.5166 14.3741 14.0541 14.0074 13.7125C13.6408 13.3708 12.7908 12.9833 11.4574 12.55C10.0241 12.1 9.04077 11.5625 8.50744 10.9375C7.9741 10.3125 7.70744 9.54995 7.70744 8.64995C7.70744 7.56662 8.05744 6.72495 8.75744 6.12495C9.45744 5.52495 10.1741 5.18329 10.9074 5.09995V3.99995C10.9074 3.44767 11.3552 2.99995 11.9074 2.99995C12.4597 2.99995 12.9074 3.44767 12.9074 3.99995V5.09995C13.7408 5.23329 14.4283 5.53745 14.9699 6.01245C15.2722 6.27751 15.529 6.57501 15.7405 6.90494C16.0265 7.35116 15.7773 7.91434 15.2908 8.1247L15.2718 8.13294C14.7471 8.35985 14.1635 8.07311 13.7833 7.64626C13.6831 7.53389 13.5745 7.43512 13.4574 7.34995C13.0908 7.08329 12.5908 6.94995 11.9574 6.94995C11.2241 6.94995 10.6658 7.11245 10.2824 7.43745C9.8991 7.76245 9.70744 8.16662 9.70744 8.64995C9.70744 9.19995 9.95744 9.63329 10.4574 9.94995C10.9574 10.2666 11.8241 10.6 13.0574 10.95C14.2074 11.2833 15.0783 11.8125 15.6699 12.5375C16.2616 13.2625 16.5574 14.1 16.5574 15.05C16.5574 16.2333 16.2074 17.1333 15.5074 17.75C14.8074 18.3666 13.9408 18.75 12.9074 18.9V20C12.9074 20.5522 12.4597 21 11.9074 21Z" />
  </svg>
);

export const DownloadOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="download">
        <rect width="24" height="24" opacity="0" />
        <rect x="4" y="18" width="16" height="2" rx="1" ry="1" />
        <rect
          x="3"
          y="17"
          width="4"
          height="2"
          rx="1"
          ry="1"
          transform="rotate(-90 5 18)"
        />
        <rect
          x="17"
          y="17"
          width="4"
          height="2"
          rx="1"
          ry="1"
          transform="rotate(-90 19 18)"
        />
        <path d="M12 15a1 1 0 0 1-.58-.18l-4-2.82a1 1 0 0 1-.24-1.39 1 1 0 0 1 1.4-.24L12 12.76l3.4-2.56a1 1 0 0 1 1.2 1.6l-4 3a1 1 0 0 1-.6.2z" />
        <path d="M12 13a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

export const DuplicateOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 13V12C9 10.346 10.346 9 12 9H13V5.667C13 5.299 12.701 5 12.333 5H5.667C5.299 5 5 5.299 5 5.667V12.333C5 12.701 5.299 13 5.667 13H9ZM9 15H5.667C4.196 15 3 13.804 3 12.333V5.667C3 4.196 4.196 3 5.667 3H12.333C13.804 3 15 4.196 15 5.667V9H18C19.654 9 21 10.346 21 12V18C21 19.654 19.654 21 18 21H12C10.346 21 9 19.654 9 18V15ZM12 11C11.449 11 11 11.449 11 12V18C11 18.551 11.449 19 12 19H18C18.552 19 19 18.551 19 18V12C19 11.449 18.552 11 18 11H12Z"
    />
    <mask
      id="mask0_725_12898"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13V12C9 10.346 10.346 9 12 9H13V5.667C13 5.299 12.701 5 12.333 5H5.667C5.299 5 5 5.299 5 5.667V12.333C5 12.701 5.299 13 5.667 13H9ZM9 15H5.667C4.196 15 3 13.804 3 12.333V5.667C3 4.196 4.196 3 5.667 3H12.333C13.804 3 15 4.196 15 5.667V9H18C19.654 9 21 10.346 21 12V18C21 19.654 19.654 21 18 21H12C10.346 21 9 19.654 9 18V15ZM12 11C11.449 11 11 11.449 11 12V18C11 18.551 11.449 19 12 19H18C18.552 19 19 18.551 19 18V12C19 11.449 18.552 11 18 11H12Z"
      />
    </mask>
    <g mask="url(#mask0_725_12898)"></g>
  </svg>
);

//E
export const EditOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="edit">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.4 7.34L16.66 4.6A2 2 0 0 0 14 4.53l-9 9a2 2 0 0 0-.57 1.21L4 18.91a1 1 0 0 0 .29.8A1 1 0 0 0 5 20h.09l4.17-.38a2 2 0 0 0 1.21-.57l9-9a1.92 1.92 0 0 0-.07-2.71zM9.08 17.62l-3 .28.27-3L12 9.32l2.7 2.7zM16 10.68L13.32 8l1.95-2L18 8.73z" />
      </g>
    </g>
  </svg>
);

export const Edit2Outline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="edit-2">
        <rect width="24" height="24" opacity="0" />
        <path d="M19 20H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2z" />
        <path d="M5 18h.09l4.17-.38a2 2 0 0 0 1.21-.57l9-9a1.92 1.92 0 0 0-.07-2.71L16.66 2.6A2 2 0 0 0 14 2.53l-9 9a2 2 0 0 0-.57 1.21L4 16.91a1 1 0 0 0 .29.8A1 1 0 0 0 5 18zM15.27 4L18 6.73l-2 1.95L13.32 6zm-8.9 8.91L12 7.32l2.7 2.7-5.6 5.6-3 .28z" />
      </g>
    </g>
  </svg>
);

export const EmbeddingsOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 6C11.5 7.38071 10.3807 8.5 9 8.5C7.61929 8.5 6.5 7.38071 6.5 6C6.5 4.61929 7.61929 3.5 9 3.5C10.3807 3.5 11.5 4.61929 11.5 6ZM11.4968 9.12523C10.8125 9.67265 9.94448 10 9 10C8.83503 10 8.67239 9.99001 8.51265 9.97061L7.35003 14.2336C8.89489 14.7874 10 16.2646 10 18C10 20.2091 8.20914 22 6 22C3.79086 22 2 20.2091 2 18C2 15.8383 3.71477 14.0771 5.85827 14.0025L7.08305 9.5116C5.8418 8.83257 5 7.51459 5 6C5 3.79086 6.79086 2 9 2C11.2091 2 13 3.79086 13 6C13 6.71768 12.811 7.39122 12.48 7.97355L15.7722 11.6773C16.4089 11.2496 17.1753 11 18 11C20.2091 11 22 12.7909 22 15C22 17.2091 20.2091 19 18 19C15.7909 19 14 17.2091 14 15C14 14.1584 14.2599 13.3775 14.7039 12.7332L11.4968 9.12523ZM20.5 15C20.5 16.3807 19.3807 17.5 18 17.5C16.6193 17.5 15.5 16.3807 15.5 15C15.5 13.6193 16.6193 12.5 18 12.5C19.3807 12.5 20.5 13.6193 20.5 15ZM6 20.5C7.38071 20.5 8.5 19.3807 8.5 18C8.5 16.6193 7.38071 15.5 6 15.5C4.61929 15.5 3.5 16.6193 3.5 18C3.5 19.3807 4.61929 20.5 6 20.5Z"
    />
  </svg>
);

export const ExternalLinkOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="external-link">
        <rect width="24" height="24" opacity="0" />
        <path d="M20 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1z" />
        <path d="M16 5h1.58l-6.29 6.28a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L19 6.42V8a1 1 0 0 0 1 1 1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z" />
      </g>
    </g>
  </svg>
);

export const ExpandOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="expand">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M20 5a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L18 7.42V10a1 1 0 0 0 1 1 1 1 0 0 0 1-1z" />
        <path d="M10.71 13.29a1 1 0 0 0-1.42 0L6 16.57V14a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H7.42l3.29-3.29a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

export const ExperimentOutline = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7325 8.3969L12.9778 9.61741L5.58892 16.9977C4.90368 17.6822 3.79253 17.6823 3.10751 16.9981C2.42238 16.3137 2.42238 15.2042 3.10751 14.5198L10.4967 7.13917L11.7245 8.38888L11.7244 8.38895L11.7325 8.3969Z"
      stroke="currentColor"
      strokeWidth="1.2"
      fill="none"
    />
    <circle
      cx="12"
      cy="5"
      r="0.75"
      stroke="currentColor"
      strokeWidth="0.5"
      fill="none"
    />
    <circle
      cx="15"
      cy="4"
      r="0.75"
      stroke="currentColor"
      strokeWidth="0.5"
      fill="none"
    />
    <circle
      cx="14.5"
      cy="7.5"
      r="1.2"
      stroke="currentColor"
      strokeWidth="0.6"
      fill="none"
    />
  </svg>
);

export const EyeOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.77475 4.16985C14.7548 4.01401 17.6914 8.65901 18.2231 9.58568C18.3698 9.84235 18.3698 10.1582 18.2231 10.4148C17.5114 11.6557 14.8314 15.7132 10.2256 15.8307C10.1573 15.8323 10.0889 15.8332 10.0206 15.8332C5.13475 15.8332 2.30142 11.329 1.77725 10.4148C1.62975 10.1582 1.62975 9.84235 1.77725 9.58568C2.48892 8.34485 5.16808 4.28651 9.77475 4.16985ZM10.1831 14.1648C6.59475 14.2482 4.25392 11.179 3.47725 9.99651C4.33225 8.65901 6.48558 5.92068 9.81725 5.83568C13.3914 5.74485 15.7456 8.82151 16.5223 10.004C15.6681 11.3415 13.5139 14.0798 10.1831 14.1648ZM7.08333 10.0002C7.08333 8.39185 8.39167 7.08351 10 7.08351C11.6083 7.08351 12.9167 8.39185 12.9167 10.0002C12.9167 11.6085 11.6083 12.9168 10 12.9168C8.39167 12.9168 7.08333 11.6085 7.08333 10.0002ZM8.75 10.0002C8.75 10.6893 9.31083 11.2502 10 11.2502C10.6892 11.2502 11.25 10.6893 11.25 10.0002C11.25 9.31101 10.6892 8.75018 10 8.75018C9.31083 8.75018 8.75 9.31101 8.75 10.0002Z"
    />
    <mask
      id="mask0_935_15127"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="4"
      width="18"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.77475 4.16985C14.7548 4.01401 17.6914 8.65901 18.2231 9.58568C18.3698 9.84235 18.3698 10.1582 18.2231 10.4148C17.5114 11.6557 14.8314 15.7132 10.2256 15.8307C10.1573 15.8323 10.0889 15.8332 10.0206 15.8332C5.13475 15.8332 2.30142 11.329 1.77725 10.4148C1.62975 10.1582 1.62975 9.84235 1.77725 9.58568C2.48892 8.34485 5.16808 4.28651 9.77475 4.16985ZM10.1831 14.1648C6.59475 14.2482 4.25392 11.179 3.47725 9.99651C4.33225 8.65901 6.48558 5.92068 9.81725 5.83568C13.3914 5.74485 15.7456 8.82151 16.5223 10.004C15.6681 11.3415 13.5139 14.0798 10.1831 14.1648ZM7.08333 10.0002C7.08333 8.39185 8.39167 7.08351 10 7.08351C11.6083 7.08351 12.9167 8.39185 12.9167 10.0002C12.9167 11.6085 11.6083 12.9168 10 12.9168C8.39167 12.9168 7.08333 11.6085 7.08333 10.0002ZM8.75 10.0002C8.75 10.6893 9.31083 11.2502 10 11.2502C10.6892 11.2502 11.25 10.6893 11.25 10.0002C11.25 9.31101 10.6892 8.75018 10 8.75018C9.31083 8.75018 8.75 9.31101 8.75 10.0002Z"
      />
    </mask>
    <g mask="url(#mask0_935_15127)"></g>
  </svg>
);

export const EyeOffOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="eye-off">
        <rect width="24" height="24" opacity="0" />
        <path d="M4.71 3.29a1 1 0 0 0-1.42 1.42l5.63 5.63a3.5 3.5 0 0 0 4.74 4.74l5.63 5.63a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM12 13.5a1.5 1.5 0 0 1-1.5-1.5v-.07l1.56 1.56z" />
        <path d="M12.22 17c-4.3.1-7.12-3.59-8-5a13.7 13.7 0 0 1 2.24-2.72L5 7.87a15.89 15.89 0 0 0-2.87 3.63 1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25a9.48 9.48 0 0 0 3.23-.67l-1.58-1.58a7.74 7.74 0 0 1-1.7.25z" />
        <path d="M21.87 11.5c-.64-1.11-4.17-6.68-10.14-6.5a9.48 9.48 0 0 0-3.23.67l1.58 1.58a7.74 7.74 0 0 1 1.7-.25c4.29-.11 7.11 3.59 8 5a13.7 13.7 0 0 1-2.29 2.72L19 16.13a15.89 15.89 0 0 0 2.91-3.63 1 1 0 0 0-.04-1z" />
      </g>
    </g>
  </svg>
);

//F

export const FileAdd = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="file-add">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.74 7.33l-4.44-5a1 1 0 0 0-.74-.33h-8A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V8a1 1 0 0 0-.26-.67zM14 15h-1v1a1 1 0 0 1-2 0v-1h-1a1 1 0 0 1 0-2h1v-1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2zm.71-7a.79.79 0 0 1-.71-.85V4l3.74 4z" />
      </g>
    </g>
  </svg>
);

export const FileAddOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="file-add">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.74 8.33l-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM14 5l2.74 3h-2a.79.79 0 0 1-.74-.85zm3.44 15H6.56a.53.53 0 0 1-.56-.5v-15a.53.53 0 0 1 .56-.5H12v3.15A2.79 2.79 0 0 0 14.71 10H18v9.5a.53.53 0 0 1-.56.5z" />
        <path d="M14 13h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const FileOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="file">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.74 8.33l-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM17.65 9h-3.94a.79.79 0 0 1-.71-.85V4h.11zm-.21 11H6.56a.53.53 0 0 1-.56-.5v-15a.53.53 0 0 1 .56-.5H11v4.15A2.79 2.79 0 0 0 13.71 11H18v8.5a.53.53 0 0 1-.56.5z" />
      </g>
    </g>
  </svg>
);

export const FileTextOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="file-text">
        <rect width="24" height="24" opacity="0" />
        <path d="M15 16H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z" />
        <path d="M9 14h3a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2z" />
        <path d="M19.74 8.33l-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM14 5l2.74 3h-2a.79.79 0 0 1-.74-.85zm3.44 15H6.56a.53.53 0 0 1-.56-.5v-15a.53.53 0 0 1 .56-.5H12v3.15A2.79 2.79 0 0 0 14.71 10H18v9.5a.53.53 0 0 1-.56.5z" />
      </g>
    </g>
  </svg>
);

export const FireOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4941 21.0015H11.5011C13.5091 21.0015 15.3951 20.2065 16.8141 18.7605C19.7291 15.7895 19.7241 10.9565 16.8041 7.99247L12.2141 3.30347C11.8331 2.91147 11.1971 2.91147 10.8001 3.28847C10.5861 3.49247 10.4731 3.78147 10.4921 4.07647C10.5001 4.21547 10.5001 4.35447 10.5001 4.50147C10.5001 7.05847 9.8581 8.56947 9.5031 8.94347C9.3521 8.77747 9.0781 8.34047 8.8481 7.45147C8.7581 7.10347 8.4881 6.83047 8.1411 6.73647C7.7921 6.64547 7.4231 6.74347 7.1691 6.99747L6.1861 7.99147C3.2771 10.9565 3.2811 15.7895 6.1951 18.7595C7.6061 20.2045 9.4881 20.9995 11.4941 21.0015ZM7.6241 17.3605C5.5061 15.2015 5.4631 11.7155 7.4951 9.51647C8.1641 10.7755 8.9921 11.0015 9.5001 11.0015C11.1581 11.0015 12.0891 8.82347 12.3911 6.34147L15.3771 9.39247C17.5381 11.5875 17.5421 15.1625 15.3861 17.3605C14.3471 18.4185 12.9681 19.0015 11.5011 19.0015H11.4961C10.0321 19.0005 8.6581 18.4175 7.6241 17.3605Z"
      />
      <g mask="url(#mask0)"></g>
    </g>
  </svg>
);

export const FolderOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="folder">
        <rect width="24" height="24" opacity="0" />
        <path d="M19.5 20.5h-15A2.47 2.47 0 0 1 2 18.07V5.93A2.47 2.47 0 0 1 4.5 3.5h4.6a1 1 0 0 1 .77.37l2.6 3.18h7A2.47 2.47 0 0 1 22 9.48v8.59a2.47 2.47 0 0 1-2.5 2.43zM4 13.76v4.31a.46.46 0 0 0 .5.43h15a.46.46 0 0 0 .5-.43V9.48a.46.46 0 0 0-.5-.43H12a1 1 0 0 1-.77-.37L8.63 5.5H4.5a.46.46 0 0 0-.5.43z" />
      </g>
    </g>
  </svg>
);

export const FunnelOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="funnel">
        <rect width="24" height="24" opacity="0" />
        <path d="M13.9 22a1 1 0 0 1-.6-.2l-4-3.05a1 1 0 0 1-.39-.8v-3.27l-4.8-9.22A1 1 0 0 1 5 4h14a1 1 0 0 1 .86.49 1 1 0 0 1 0 1l-5 9.21V21a1 1 0 0 1-.55.9 1 1 0 0 1-.41.1zm-3-4.54l2 1.53v-4.55A1 1 0 0 1 13 14l4.3-8H6.64l4.13 8a1 1 0 0 1 .11.46z" />
      </g>
    </g>
  </svg>
);

//G

export const GitBranchOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="6" y1="3" x2="6" y2="15"></line>
    <circle cx="18" cy="6" r="3" fill="none"></circle>
    <circle cx="6" cy="18" r="3" fill="none"></circle>
    <path d="M18 9a9 9 0 0 1-9 9" fill="none"></path>
  </svg>
);

export const GitHub = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <g data-name="Layer 2">
      <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0" />
      <path d="M12 1A10.89 10.89 0 0 0 1 11.77 10.79 10.79 0 0 0 8.52 22c.55.1.75-.23.75-.52v-1.83c-3.06.65-3.71-1.44-3.71-1.44a2.86 2.86 0 0 0-1.22-1.58c-1-.66.08-.65.08-.65a2.31 2.31 0 0 1 1.68 1.11 2.37 2.37 0 0 0 3.2.89 2.33 2.33 0 0 1 .7-1.44c-2.44-.27-5-1.19-5-5.32a4.15 4.15 0 0 1 1.11-2.91 3.78 3.78 0 0 1 .11-2.84s.93-.29 3 1.1a10.68 10.68 0 0 1 5.5 0c2.1-1.39 3-1.1 3-1.1a3.78 3.78 0 0 1 .11 2.84A4.15 4.15 0 0 1 19 11.2c0 4.14-2.58 5.05-5 5.32a2.5 2.5 0 0 1 .75 2v2.95c0 .35.2.63.75.52A10.8 10.8 0 0 0 23 11.77 10.89 10.89 0 0 0 12 1" />
    </g>
  </svg>
);

export const Grid = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="grid">
        <rect width="24" height="24" opacity="0" />
        <path d="M9 3H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
        <path d="M19 3h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
        <path d="M9 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" />
        <path d="M19 13h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z" />
      </g>
    </g>
  </svg>
);

export const GridOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="grid">
        <rect width="24" height="24" opacity="0" />
        <path d="M9 3H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM5 9V5h4v4z" />
        <path d="M19 3h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-4 6V5h4v4z" />
        <path d="M9 13H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 6v-4h4v4z" />
        <path d="M19 13h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-4 6v-4h4v4z" />
      </g>
    </g>
  </svg>
);

export const GraphQL = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.657L20.958 6.828V17.172L12 22.343L3.042 17.172V6.828L12 1.657ZM4.048 7.409V15.006L10.629 3.61L4.048 7.409ZM12 3.242L4.415 16.379H19.585L12 3.242ZM18.58 17.384H5.42L12 21.183L18.58 17.384ZM19.952 15.006L13.373 3.61L19.952 7.409V15.006Z"
    />
    <circle cx="12" cy="2.237" r="2.117" />
    <circle cx="20.455" cy="7.119" r="2.117" />
    <circle cx="20.455" cy="16.882" r="2.117" />
    <circle cx="12" cy="21.763" r="2.117" />
    <circle cx="3.544" cy="16.882" r="2.117" />
    <circle cx="3.544" cy="7.119" r="2.117" />
  </svg>
);

export const HalfMoonHalfSunOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.88518 8.68896C7.75814 8.4835 8.40614 9.00284 8.68987 9.55225C8.95537 10.0667 8.99811 10.7297 8.74748 11.3081C8.5089 11.8599 8.44142 12.4705 8.55412 13.061C8.6669 13.6517 8.9541 14.1955 9.37932 14.6206C9.80454 15.0457 10.3483 15.3332 10.9389 15.4458C11.5295 15.5583 12.141 15.4903 12.6928 15.2515C13.2706 15.0017 13.9337 15.0425 14.4487 15.3081C14.9995 15.5924 15.5175 16.2418 15.311 17.1147C15.0236 18.3268 14.4175 19.4414 13.5561 20.3413C12.6946 21.2412 11.608 21.8949 10.4096 22.2349C9.21104 22.5748 7.94245 22.5885 6.73674 22.2749C5.53125 21.9612 4.43113 21.3314 3.55022 20.4507C2.66926 19.5698 2.0389 18.4697 1.72502 17.2642C1.41119 16.0584 1.42527 14.79 1.76506 13.5913C2.10485 12.3928 2.75795 11.3064 3.65764 10.4448C4.5575 9.58317 5.67196 8.97749 6.8842 8.68994L6.88518 8.68896ZM6.79924 10.8003C6.14594 11.0366 5.54625 11.4058 5.04143 11.8892C4.39866 12.5047 3.9316 13.281 3.68889 14.1372C3.44624 14.9934 3.43642 15.899 3.66057 16.7603C3.88477 17.6214 4.33503 18.4075 4.96428 19.0366C5.59353 19.6656 6.37957 20.1153 7.24065 20.3394C8.10182 20.5633 9.00763 20.5538 9.86369 20.311C10.7196 20.0682 11.4955 19.6011 12.1108 18.9585C12.5943 18.4534 12.9624 17.8525 13.1987 17.1987C12.3568 17.5028 11.4468 17.578 10.5639 17.4097C9.57969 17.2219 8.67386 16.743 7.96526 16.0347C7.25661 15.3261 6.77721 14.4204 6.58928 13.436C6.42069 12.5527 6.495 11.6425 6.79924 10.8003Z"
    />
    <path d="M11.5004 7.49951C12.8265 7.49953 14.0979 8.02669 15.0356 8.96436C15.9732 9.90203 16.5004 11.1734 16.5004 12.4995C16.5004 13.0518 16.0527 13.4995 15.5004 13.4995C14.9481 13.4995 14.5004 13.0518 14.5004 12.4995C14.5004 11.7039 14.1841 10.941 13.6215 10.3784C13.0589 9.81583 12.296 9.49953 11.5004 9.49951C10.9481 9.49951 10.5004 9.0518 10.5004 8.49951C10.5004 7.94723 10.9481 7.49951 11.5004 7.49951Z" />
    <path d="M21.5004 11.4995C22.0527 11.4996 22.5004 11.9473 22.5004 12.4995C22.5004 13.0518 22.0527 13.4995 21.5004 13.4995H19.5004C18.9481 13.4995 18.5004 13.0518 18.5004 12.4995C18.5004 11.9472 18.9481 11.4995 19.5004 11.4995H21.5004Z" />
    <path d="M17.7934 4.79248C18.1839 4.40207 18.8169 4.40206 19.2074 4.79248C19.5978 5.18298 19.5978 5.81604 19.2074 6.20654L17.9516 7.4624C17.5611 7.85289 16.9281 7.85283 16.5375 7.4624C16.1471 7.07187 16.147 6.43884 16.5375 6.04834L17.7934 4.79248Z" />
    <path d="M11.5004 1.49951C12.0527 1.49955 12.5004 1.94725 12.5004 2.49951V4.49951C12.5004 5.05177 12.0527 5.49947 11.5004 5.49951C10.9481 5.49951 10.5004 5.0518 10.5004 4.49951V2.49951C10.5004 1.94723 10.9481 1.49951 11.5004 1.49951Z" />
  </svg>
);

//H

export const HistoryOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M12.3436 2.13235C14.3214 2.13235 16.2548 2.71909 17.8993 3.8179C19.5437 4.91669 20.826 6.47802 21.5829 8.30521C22.3398 10.1325 22.5371 12.1437 22.1512 14.0835C21.7654 16.0232 20.8134 17.8052 19.4149 19.2036C18.0165 20.6021 16.2345 21.5541 14.2948 21.94C12.355 22.3258 10.3437 22.1285 8.51648 21.3716C6.68929 20.6147 5.12796 19.3324 4.02917 17.688C2.93036 16.0435 2.34363 14.1102 2.34363 12.1324C2.34363 11.5801 2.79134 11.1324 3.34363 11.1324C3.89591 11.1324 4.34363 11.5801 4.34363 12.1324C4.34363 13.7146 4.81321 15.2611 5.69226 16.5767C6.57127 17.8922 7.82039 18.9175 9.2821 19.523C10.7438 20.1284 12.3524 20.2877 13.9042 19.979C15.456 19.6704 16.882 18.9084 18.0009 17.7896C19.1197 16.6708 19.8816 15.2447 20.1903 13.6929C20.4989 12.1411 20.3397 10.5326 19.7343 9.07083C19.1287 7.60912 18.1035 6.36 16.788 5.48099C15.4729 4.6023 13.9272 4.13274 12.3456 4.13235C10.0882 4.14131 7.92171 5.02235 6.29871 6.59134L5.75769 7.13235H8.34363C8.89591 7.13235 9.34363 7.58007 9.34363 8.13235C9.34363 8.68464 8.89591 9.13235 8.34363 9.13235H3.34363C3.28696 9.13235 3.23171 9.12579 3.17761 9.11673C3.16721 9.11498 3.15672 9.11392 3.14636 9.11185C3.13486 9.10954 3.12354 9.10673 3.11218 9.10403C3.09161 9.09915 3.07095 9.09461 3.05066 9.08841C3.00201 9.07352 2.95522 9.05454 2.91003 9.03275C2.88819 9.02222 2.86677 9.01077 2.84558 8.99857C2.68479 8.90592 2.55212 8.77046 2.46375 8.60696C2.45632 8.59321 2.44997 8.57899 2.44324 8.56497C2.42143 8.51967 2.40146 8.47313 2.3866 8.42435C2.37141 8.37444 2.36158 8.32332 2.35437 8.272C2.34798 8.22632 2.34363 8.1798 2.34363 8.13235V3.13235C2.34363 2.58007 2.79134 2.13235 3.34363 2.13235C3.89591 2.13235 4.34363 2.58007 4.34363 3.13235V5.71829L4.89636 5.16556L5.28992 4.80228C7.23605 3.09439 9.73887 2.14217 12.3397 2.13235H12.3436Z" />
    <path d="M12.3436 6.13235C12.8959 6.13235 13.3436 6.58007 13.3436 7.13235V11.5142L16.7909 13.2378C17.2849 13.4848 17.4851 14.0856 17.2382 14.5796C16.9912 15.0736 16.3903 15.2739 15.8964 15.0269L11.8964 13.0269C11.5576 12.8575 11.3436 12.5111 11.3436 12.1324V7.13235C11.3436 6.58007 11.7913 6.13235 12.3436 6.13235Z" />
  </svg>
);

export const HomeOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="home">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.42 10.18L12.71 2.3a1 1 0 0 0-1.42 0l-7.71 7.89A2 2 0 0 0 3 11.62V20a2 2 0 0 0 1.89 2h14.22A2 2 0 0 0 21 20v-8.38a2.07 2.07 0 0 0-.58-1.44zM10 20v-6h4v6zm9 0h-3v-7a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v7H5v-8.42l7-7.15 7 7.19z" />
      </g>
    </g>
  </svg>
);

//I

export const IDOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M9.57031 7.91936H7.34375V16.0795H9.57031V17.6781H2.94043V16.0795H5.16699V7.91936H2.94043V6.3217H9.57031V7.91936Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2285 6.3217C16.0558 6.3217 16.8208 6.41812 17.5234 6.61076C18.2374 6.80343 18.8556 7.12091 19.377 7.56291C19.9094 7.99346 20.3226 8.57134 20.6172 9.29631C20.9119 10.0216 21.0596 10.9175 21.0596 11.9828C21.0596 13.0481 20.9118 13.9493 20.6172 14.686C20.3225 15.4111 19.9095 15.995 19.377 16.4369C18.8556 16.8789 18.2374 17.1964 17.5234 17.3891C16.8208 17.5817 16.0557 17.6781 15.2285 17.6781H12.084V6.3217H15.2285ZM14.1064 15.893H15.127C15.6255 15.893 16.1015 15.8416 16.5547 15.7397C17.0193 15.6377 17.4333 15.4564 17.7959 15.1957C18.1584 14.9238 18.4415 14.5327 18.6455 14.0229C18.8608 13.5016 18.9687 12.8214 18.9688 11.9828C18.9688 11.1442 18.8608 10.4694 18.6455 9.9594C18.4415 9.43827 18.1584 9.04716 17.7959 8.78654C17.4332 8.51455 17.0193 8.33327 16.5547 8.2426C16.1015 8.14062 15.6255 8.0893 15.127 8.08928H14.1064V15.893Z"
    />
  </svg>
);

export const ImageOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="image">
        <rect width="24" height="24" opacity="0" />
        <path d="M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM6 5h12a1 1 0 0 1 1 1v8.36l-3.2-2.73a2.77 2.77 0 0 0-3.52 0L5 17.7V6a1 1 0 0 1 1-1zm12 14H6.56l7-5.84a.78.78 0 0 1 .93 0L19 17v1a1 1 0 0 1-1 1z" />
        <circle cx="8" cy="8.5" r="1.5" />
      </g>
    </g>
  </svg>
);

export const Info = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="info">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        ></rect>
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 14a1 1 0 0 1-2 0v-5a1 1 0 0 1 2 0zm-1-7a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"></path>
      </g>
    </g>
  </svg>
);

export const InfoFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="info">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 14a1 1 0 0 1-2 0v-5a1 1 0 0 1 2 0zm-1-7a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

export const InfoOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="info">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <circle cx="12" cy="8" r="1" />
        <path d="M12 10a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

//J
//K
export const KeyOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="none"
      d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
    ></path>
  </svg>
);
//L

export const LifeBuoy = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" fill="none"></circle>
    <circle cx="12" cy="12" r="4" fill="none"></circle>
    <line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line>
    <line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line>
    <line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line>
    <line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line>
    <line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>
  </svg>
);

export const ListOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="list">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <circle cx="4" cy="7" r="1" />
        <circle cx="4" cy="12" r="1" />
        <circle cx="4" cy="17" r="1" />
        <rect x="7" y="11" width="14" height="2" rx=".94" ry=".94" />
        <rect x="7" y="16" width="14" height="2" rx=".94" ry=".94" />
        <rect x="7" y="6" width="14" height="2" rx=".94" ry=".94" />
      </g>
    </g>
  </svg>
);

export const LoaderOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="loader">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1z" />
        <path d="M21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" />
        <path d="M6 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1z" />
        <path d="M6.22 5a1 1 0 0 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41z" />
        <path d="M17 8.14a1 1 0 0 0 .69-.28l1.44-1.39A1 1 0 0 0 17.78 5l-1.44 1.42a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.31z" />
        <path d="M12 18a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1z" />
        <path d="M17.73 16.14a1 1 0 0 0-1.39 1.44L17.78 19a1 1 0 0 0 .69.28 1 1 0 0 0 .72-.3 1 1 0 0 0 0-1.42z" />
        <path d="M6.27 16.14l-1.44 1.39a1 1 0 0 0 0 1.42 1 1 0 0 0 .72.3 1 1 0 0 0 .67-.25l1.44-1.39a1 1 0 0 0-1.39-1.44z" />
      </g>
    </g>
  </svg>
);

export const LoadingOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    css={css`
      animation: ${loadingCircleKeyframes} 1s infinite linear;
    `}
  >
    <g id="loading">
      <mask
        id="mask0_804_24"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12ZM4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4C7.589 4 4 7.589 4 12Z"
          fill="inherit"
        />
      </mask>
      <g mask="url(#mask0_804_24)">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4V12H20C20 12.5523 20.4477 13 21 13C21.5523 13 22 12.5523 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612Z"
          fill="inherit"
        />
      </g>
    </g>
  </svg>
);

export const LogOut = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="log-out">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M7 6a1 1 0 0 0 0-2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2H6V6z" />
        <path d="M20.82 11.42l-2.82-4a1 1 0 0 0-1.39-.24 1 1 0 0 0-.24 1.4L18.09 11H10a1 1 0 0 0 0 2h8l-1.8 2.4a1 1 0 0 0 .2 1.4 1 1 0 0 0 .6.2 1 1 0 0 0 .8-.4l3-4a1 1 0 0 0 .02-1.18z" />
      </g>
    </g>
  </svg>
);

//M
export const MaximizeOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="maximize">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z" />
        <path d="M13 10h-1V9a1 1 0 0 0-2 0v1H9a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const MessageSquareOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="message-square">
        <rect width="24" height="24" opacity="0" />
        <circle cx="12" cy="11" r="1" />
        <circle cx="16" cy="11" r="1" />
        <circle cx="8" cy="11" r="1" />
        <path d="M19 3H5a3 3 0 0 0-3 3v15a1 1 0 0 0 .51.87A1 1 0 0 0 3 22a1 1 0 0 0 .51-.14L8 19.14a1 1 0 0 1 .55-.14H19a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm1 13a1 1 0 0 1-1 1H8.55a3 3 0 0 0-1.55.43l-3 1.8V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" />
      </g>
    </g>
  </svg>
);

export const MessagesSquareOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{ fill: "none", stroke: "currentColor" }}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    <path d="M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1" />
  </svg>
);

export const MinimizeOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="minimize">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z" />
        <path d="M13 10H9a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const MinusCircleOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="minus-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M15 11H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const MinusOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="minus">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M19 13H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z" />
      </g>
    </g>
  </svg>
);

export const MoonOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.279 21.9783H12.179C10.8075 21.9678 9.4519 21.6838 8.19154 21.1429C6.93119 20.602 5.79142 19.8151 4.83898 18.8283C3.07283 16.9395 2.06886 14.4636 2.02085 11.8782C1.97283 9.29278 2.88417 6.78124 4.57898 4.82825C5.67086 3.60459 7.04351 2.66433 8.57898 2.08825C8.75814 2.01931 8.95336 2.00339 9.14133 2.0424C9.32929 2.08142 9.50205 2.1737 9.63898 2.30825C9.7658 2.43757 9.85511 2.59891 9.89738 2.77503C9.93965 2.95116 9.93329 3.13546 9.87898 3.30825C9.33094 4.80919 9.22236 6.4353 9.56598 7.99577C9.9096 9.55625 10.6912 10.9863 11.819 12.1183C12.9573 13.2426 14.3908 14.0215 15.9535 14.3649C17.5162 14.7082 19.1442 14.6019 20.649 14.0583C20.8281 13.9952 21.0214 13.9845 21.2064 14.0273C21.3914 14.0701 21.5604 14.1646 21.6936 14.3C21.8268 14.4353 21.9188 14.6057 21.9587 14.7913C21.9986 14.977 21.9848 15.1701 21.919 15.3483C21.4081 16.712 20.6101 17.9499 19.579 18.9783C18.6198 19.9346 17.4811 20.6919 16.2284 21.2067C14.9756 21.7216 13.6334 21.9838 12.279 21.9783ZM7.43898 4.89825C6.93666 5.25055 6.47691 5.65995 6.06898 6.11825C4.69352 7.69439 3.9524 9.72517 3.98935 11.8168C4.02631 13.9083 4.8387 15.9117 6.26898 17.4382C7.03751 18.2364 7.95825 18.8725 8.97678 19.3087C9.99531 19.745 11.091 19.9727 12.199 19.9783H12.279C13.6052 19.9775 14.9121 19.6605 16.0912 19.0535C17.2704 18.4466 18.2878 17.5671 19.059 16.4883C17.4873 16.6919 15.8899 16.5326 14.3894 16.0226C12.8889 15.5127 11.5253 14.6656 10.4032 13.5464C9.28114 12.4272 8.43051 11.0658 7.91666 9.5666C7.40281 8.06743 7.2394 6.47042 7.43898 4.89825Z" />
  </svg>
);

export const MoreHorizontalOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="more-horizotnal">
        <rect width="24" height="24" opacity="0" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="19" cy="12" r="2" />
        <circle cx="5" cy="12" r="2" />
      </g>
    </g>
  </svg>
);

export const OptionsOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="options">
        <rect width="24" height="24" opacity="0" />
        <path d="M7 14.18V3a1 1 0 0 0-2 0v11.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-1.18a3 3 0 0 0 0-5.64zM6 18a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
        <path d="M21 13a3 3 0 0 0-2-2.82V3a1 1 0 0 0-2 0v7.18a3 3 0 0 0 0 5.64V21a1 1 0 0 0 2 0v-5.18A3 3 0 0 0 21 13zm-3 1a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
        <path d="M15 5a3 3 0 1 0-4 2.82V21a1 1 0 0 0 2 0V7.82A3 3 0 0 0 15 5zm-3 1a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

//P
export const PaperPlaneOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="paper-plane">
        <rect width="24" height="24" opacity="0" />
        <path d="M21 4a1.31 1.31 0 0 0-.06-.27v-.09a1 1 0 0 0-.2-.3 1 1 0 0 0-.29-.19h-.09a.86.86 0 0 0-.31-.15H20a1 1 0 0 0-.3 0l-18 6a1 1 0 0 0 0 1.9l8.53 2.84 2.84 8.53a1 1 0 0 0 1.9 0l6-18A1 1 0 0 0 21 4zm-4.7 2.29l-5.57 5.57L5.16 10zM14 18.84l-1.86-5.57 5.57-5.57z" />
      </g>
    </g>
  </svg>
);

export const PersonOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="person">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z" />
        <path d="M12 13a7 7 0 0 0-7 7 1 1 0 0 0 2 0 5 5 0 0 1 10 0 1 1 0 0 0 2 0 7 7 0 0 0-7-7z" />
      </g>
    </g>
  </svg>
);

export const PieChartOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="pie-chart">
        <rect width="24" height="24" opacity="0" />
        <path d="M13 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 9 9 0 0 0-9-9zm1 8V4.07A7 7 0 0 1 19.93 10z" />
        <path d="M20.82 14.06a1 1 0 0 0-1.28.61A8 8 0 1 1 9.33 4.46a1 1 0 0 0-.66-1.89 10 10 0 1 0 12.76 12.76 1 1 0 0 0-.61-1.27z" />
      </g>
    </g>
  </svg>
);

export const PlayCircleOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="play-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M12.34 7.45a1.7 1.7 0 0 0-1.85-.3 1.6 1.6 0 0 0-1 1.48v6.74a1.6 1.6 0 0 0 1 1.48 1.68 1.68 0 0 0 .69.15 1.74 1.74 0 0 0 1.16-.45L16 13.18a1.6 1.6 0 0 0 0-2.36zm-.84 7.15V9.4l2.81 2.6z" />
      </g>
    </g>
  </svg>
);

export const PlusOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="plus">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const PlusCircleOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="plus-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M15 11h-2V9a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2z" />
      </g>
    </g>
  </svg>
);

export const PriceTagsOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="pricetags">
        <rect width="24" height="24" opacity="0" />
        <path d="M12.87 22a1.84 1.84 0 0 1-1.29-.53l-6.41-6.42a1 1 0 0 1-.29-.61L4 5.09a1 1 0 0 1 .29-.8 1 1 0 0 1 .8-.29l9.35.88a1 1 0 0 1 .61.29l6.42 6.41a1.82 1.82 0 0 1 0 2.57l-7.32 7.32a1.82 1.82 0 0 1-1.28.53zm-6-8.11l6 6 7.05-7.05-6-6-7.81-.73z" />
        <circle cx="10.5" cy="10.5" r="1.5" />
      </g>
    </g>
  </svg>
);

export const PythonSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.496 4.68179C16.7594 4.68179 17.3551 5.63521 17.6669 6.90249C18.1009 8.66251 18.1201 9.98168 17.6669 11.3537C17.2281 12.6865 16.7578 13.5744 15.496 13.5744H8.98918V14.131H13.3261V15.8009C13.3259 17.0646 12.248 17.7072 11.1552 18.0265C9.51085 18.5079 8.19258 18.4342 6.81828 18.0265C5.67068 17.686 4.64753 16.9878 4.64738 15.8009V11.63C4.64738 10.4299 5.63041 9.40347 6.81828 9.40347H11.1552C12.6 9.40325 13.8669 8.13478 13.8671 6.6271V4.68179H15.496ZM11.4277 15.2443C10.9794 15.2445 10.6132 15.6164 10.6132 16.0763C10.6132 16.5379 10.9794 16.913 11.4277 16.9132C11.8777 16.9132 12.2431 16.538 12.2431 16.0763C12.2431 15.6162 11.8777 15.2443 11.4277 15.2443Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8925 0.000149919C9.63457 -0.00332877 10.4085 0.0536574 11.1542 0.178861C12.3324 0.376977 13.3251 1.26914 13.3251 2.4562V6.6271C13.3249 7.85004 12.3613 8.85269 11.1542 8.85269H6.81828C5.34599 8.85269 4.10554 10.1277 4.10539 11.5734V13.5753H2.6132C1.35139 13.5753 0.614206 12.6504 0.305585 11.3537C-0.11062 9.61183 -0.0930083 8.57077 0.305585 6.90249C0.651145 5.44704 1.75583 4.68193 3.0175 4.68179H8.98918V4.12515H4.64738V2.4562C4.64738 1.19219 4.98102 0.506326 6.81828 0.178861C7.44183 0.067561 8.15047 0.00364161 8.8925 0.000149919ZM6.54484 1.34292C6.09489 1.34292 5.73058 1.71828 5.73039 2.17984C5.73039 2.63993 6.09477 3.01187 6.54484 3.01187C6.99329 3.01185 7.3593 2.63991 7.3593 2.17984C7.35911 1.71829 6.99317 1.34294 6.54484 1.34292Z"
      fill="currentColor"
    />
  </svg>
);

//Q
export const QuestionOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="menu-arrow-circle">
        <rect
          width="24"
          height="24"
          transform="rotate(180 12 12)"
          opacity="0"
        />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M12 6a3.5 3.5 0 0 0-3.5 3.5 1 1 0 0 0 2 0A1.5 1.5 0 1 1 12 11a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-1.16A3.49 3.49 0 0 0 12 6z" />
        <circle cx="12" cy="17" r="1" />
      </g>
    </g>
  </svg>
);

export const Refresh = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="refresh">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.3 13.43a1 1 0 0 0-1.25.65A7.14 7.14 0 0 1 12.18 19 7.1 7.1 0 0 1 5 12a7.1 7.1 0 0 1 7.18-7 7.26 7.26 0 0 1 4.65 1.67l-2.17-.36a1 1 0 0 0-1.15.83 1 1 0 0 0 .83 1.15l4.24.7h.17a1 1 0 0 0 .34-.06.33.33 0 0 0 .1-.06.78.78 0 0 0 .2-.11l.09-.11c0-.05.09-.09.13-.15s0-.1.05-.14a1.34 1.34 0 0 0 .07-.18l.75-4a1 1 0 0 0-2-.38l-.27 1.45A9.21 9.21 0 0 0 12.18 3 9.1 9.1 0 0 0 3 12a9.1 9.1 0 0 0 9.18 9A9.12 9.12 0 0 0 21 14.68a1 1 0 0 0-.7-1.25z" />
      </g>
    </g>
  </svg>
);

export const RepeatOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="repeat">
        <rect width="24" height="24" opacity="0" />
        <path d="M17.91 5h-12l1.3-1.29a1 1 0 0 0-1.42-1.42l-3 3a1 1 0 0 0 0 1.42l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.91 7h12a1.56 1.56 0 0 1 1.59 1.53V11a1 1 0 0 0 2 0V8.53A3.56 3.56 0 0 0 17.91 5z" />
        <path d="M18.21 14.29a1 1 0 0 0-1.42 1.42l1.3 1.29h-12a1.56 1.56 0 0 1-1.59-1.53V13a1 1 0 0 0-2 0v2.47A3.56 3.56 0 0 0 6.09 19h12l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 0-1.42z" />
      </g>
    </g>
  </svg>
);

export const RecordOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <circle
      cx="12"
      cy="12"
      r="10.25"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="12" cy="12" r="6" fill="currentColor" />
  </svg>
);

export const Robot = () => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6.75C6.41421 6.75 6.75 7.08579 6.75 7.5V9C6.75 9.41421 6.41421 9.75 6 9.75C5.58579 9.75 5.25 9.41421 5.25 9V7.5C5.25 7.08579 5.58579 6.75 6 6.75Z"
      fill="currentColor"
    />
    <path
      d="M10.5 6.75C10.9142 6.75 11.25 7.08579 11.25 7.5V9C11.25 9.41421 10.9142 9.75 10.5 9.75C10.0858 9.75 9.75 9.41421 9.75 9V7.5C9.75 7.08579 10.0858 6.75 10.5 6.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 0C8.66421 0 9 0.335786 9 0.75V3H12.75C13.9926 3 15 4.00736 15 5.25V7.5H15.75C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.66421 16.1642 9 15.75 9H15V11.25C15 12.4926 13.9926 13.5 12.75 13.5H3.75C2.50736 13.5 1.5 12.4926 1.5 11.25V9H0.75C0.335786 9 0 8.66421 0 8.25C0 7.83579 0.335786 7.5 0.75 7.5H1.5V5.25C1.5 4.00736 2.50736 3 3.75 3H7.5V1.5H5.25C4.83579 1.5 4.5 1.16421 4.5 0.75C4.5 0.335786 4.83579 0 5.25 0H8.25ZM3.75 4.5C3.33579 4.5 3 4.83579 3 5.25V11.25C3 11.6642 3.33579 12 3.75 12H12.75C13.1642 12 13.5 11.6642 13.5 11.25V5.25C13.5 4.83579 13.1642 4.5 12.75 4.5H3.75Z"
      fill="currentColor"
    />
  </svg>
);

// @src: lucide
export const Rocket = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
      fill="none"
    />
    <path
      d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
      fill="none"
    />
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" fill="none" />
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" fill="none" />
  </svg>
);

export const RowCollapseOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H3.9C4.31421 12.75 4.65 12.4142 4.65 12C4.65 11.5858 4.31421 11.25 3.9 11.25H3ZM5.7 11.25C5.28579 11.25 4.95 11.5858 4.95 12C4.95 12.4142 5.28579 12.75 5.7 12.75H7.5C7.91421 12.75 8.25 12.4142 8.25 12C8.25 11.5858 7.91421 11.25 7.5 11.25H5.7ZM9.3 11.25C8.88579 11.25 8.55 11.5858 8.55 12C8.55 12.4142 8.88579 12.75 9.3 12.75H11.1C11.5142 12.75 11.85 12.4142 11.85 12C11.85 11.5858 11.5142 11.25 11.1 11.25H9.3ZM12.9 11.25C12.4858 11.25 12.15 11.5858 12.15 12C12.15 12.4142 12.4858 12.75 12.9 12.75H14.7C15.1142 12.75 15.45 12.4142 15.45 12C15.45 11.5858 15.1142 11.25 14.7 11.25H12.9ZM16.5 11.25C16.0858 11.25 15.75 11.5858 15.75 12C15.75 12.4142 16.0858 12.75 16.5 12.75L18.3 12.75C18.7142 12.75 19.05 12.4142 19.05 12C19.05 11.5858 18.7142 11.25 18.3 11.25L16.5 11.25ZM20.1 11.25C19.6858 11.25 19.35 11.5858 19.35 12C19.35 12.4142 19.6858 12.75 20.1 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25H20.1ZM12.5746 15.1596L15.5744 16.7468C16.0263 17.025 16.1363 17.571 15.8174 17.9656C15.4994 18.3611 14.8754 18.4564 14.4245 18.1782L12.9816 17.55C12.9829 17.5618 12.9867 17.5728 12.9904 17.5838C12.995 17.5974 12.9996 17.6108 12.9996 17.6252V21.1251C12.9996 21.608 12.5526 22 11.9997 22C11.4467 22 10.9998 21.608 10.9998 21.1251V17.6252V17.6243L9.59887 18.3252C9.15791 18.6148 8.53096 18.5369 8.19998 18.1502C8.06499 17.9927 8 17.8081 8 17.6261C8 17.3601 8.13799 17.0967 8.39997 16.9253L11.3997 15.1753C11.7457 14.9478 12.2207 14.9408 12.5746 15.1596ZM12.5746 8.84043L15.5744 7.25325C16.0263 6.97502 16.1363 6.42904 15.8174 6.03444C15.4994 5.63895 14.8754 5.54358 14.4245 5.82182L12.9816 6.45004C12.9829 6.43826 12.9867 6.42718 12.9904 6.41617C12.995 6.40266 12.9996 6.38926 12.9996 6.3748V2.87496C12.9996 2.39198 12.5526 2 11.9997 2C11.4467 2 10.9998 2.39198 10.9998 2.87496V6.3748V6.37567L9.59887 5.67483C9.15791 5.38522 8.53096 5.46309 8.19998 5.84982C8.06499 6.00731 8 6.19193 8 6.37392C8 6.63991 8.13799 6.90327 8.39997 7.07476L11.3997 8.82468C11.7457 9.05217 12.2207 9.05917 12.5746 8.84043Z"
      fill="currentColor"
    />
  </svg>
);

export const RowExpandOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11.25C2.58579 11.25 2.25 11.5858 2.25 12C2.25 12.4142 2.58579 12.75 3 12.75H3.9C4.31421 12.75 4.65 12.4142 4.65 12C4.65 11.5858 4.31421 11.25 3.9 11.25H3ZM5.7 11.25C5.28579 11.25 4.95 11.5858 4.95 12C4.95 12.4142 5.28579 12.75 5.7 12.75H7.5C7.91421 12.75 8.25 12.4142 8.25 12C8.25 11.5858 7.91421 11.25 7.5 11.25H5.7ZM9.3 11.25C8.88579 11.25 8.55 11.5858 8.55 12C8.55 12.4142 8.88579 12.75 9.3 12.75H11.1C11.5142 12.75 11.85 12.4142 11.85 12C11.85 11.5858 11.5142 11.25 11.1 11.25H9.3ZM12.9 11.25C12.4858 11.25 12.15 11.5858 12.15 12C12.15 12.4142 12.4858 12.75 12.9 12.75H14.7C15.1142 12.75 15.45 12.4142 15.45 12C15.45 11.5858 15.1142 11.25 14.7 11.25H12.9ZM16.5 11.25C16.0858 11.25 15.75 11.5858 15.75 12C15.75 12.4142 16.0858 12.75 16.5 12.75L18.3 12.75C18.7142 12.75 19.05 12.4142 19.05 12C19.05 11.5858 18.7142 11.25 18.3 11.25L16.5 11.25ZM20.1 11.25C19.6858 11.25 19.35 11.5858 19.35 12C19.35 12.4142 19.6858 12.75 20.1 12.75H21C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25H20.1ZM11.4254 21.8405L8.42561 20.2533C7.97365 19.975 7.86366 19.4291 8.18263 19.0345C8.50061 18.639 9.12456 18.5436 9.57552 18.8219L11.0184 19.4501C11.0171 19.4383 11.0133 19.4272 11.0096 19.4162C11.005 19.4027 11.0004 19.3893 11.0004 19.3748V15.875C11.0004 15.392 11.4474 15 12.0003 15C12.5533 15 13.0002 15.392 13.0002 15.875V19.3748V19.3757L14.4011 18.6749C14.8421 18.3852 15.469 18.4631 15.8 18.8499C15.935 19.0073 16 19.192 16 19.374C16 19.6399 15.862 19.9033 15.6 20.0748L12.6003 21.8247C12.2543 22.0522 11.7793 22.0592 11.4254 21.8405ZM11.4254 2.1596L8.42561 3.74678C7.97365 4.02501 7.86366 4.57099 8.18263 4.96559C8.50061 5.36108 9.12456 5.45645 9.57552 5.17821L11.0184 4.54999C11.0171 4.56177 11.0133 4.57285 11.0096 4.58386C11.005 4.59737 11.0004 4.61077 11.0004 4.62523L11.0004 8.12507C11.0004 8.60805 11.4474 9.00003 12.0003 9.00003C12.5533 9.00003 13.0002 8.60805 13.0002 8.12507L13.0002 4.62523V4.62436L14.4011 5.3252C14.8421 5.61481 15.469 5.53694 15.8 5.15021C15.935 4.99272 16 4.8081 16 4.62611C16 4.36012 15.862 4.09676 15.6 3.92527L12.6003 2.17535C12.2543 1.94786 11.7793 1.94086 11.4254 2.1596Z"
      fill="currentColor"
    />
  </svg>
);
//S

export const SaveOutline = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g data-name="Layer 2">
        <g data-name="save">
          <rect width="24" height="24" opacity="0" />
          <path d="M20.12 8.71l-4.83-4.83A3 3 0 0 0 13.17 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7.17a3 3 0 0 0-.88-2.12zM10 19v-2h4v2zm9-1a1 1 0 0 1-1 1h-2v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2v5a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2h-3V5h3.17a1.05 1.05 0 0 1 .71.29l4.83 4.83a1 1 0 0 1 .29.71z" />
        </g>
      </g>
    </svg>
  );
};

export const Scale = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 16L19 8L22 16C21.13 16.65 20.08 17 19 17C17.92 17 16.87 16.65 16 16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M2 16L5 8L8 16C7.13 16.65 6.08 17 5 17C3.92 17 2.87 16.65 2 16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7 21H17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 7H5C7 7 10 6 12 5C14 6 17 7 19 7H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Search = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="search">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z" />
      </g>
    </g>
  </svg>
);

export const SearchOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="search">
        <rect width="24" height="24" opacity="0" />
        <path d="M20.71 19.29l-3.4-3.39A7.92 7.92 0 0 0 19 11a8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 11a6 6 0 1 1 6 6 6 6 0 0 1-6-6z" />
      </g>
    </g>
  </svg>
);

export const Server = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    style={{ fill: "none" }}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
    <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
    <line x1="6" y1="6" x2="6.01" y2="6"></line>
    <line x1="6" y1="18" x2="6.01" y2="18"></line>
  </svg>
);

export const SettingsOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="settings">
        <rect width="24" height="24" opacity="0" />
        <path
          d="M8.61 22a2.25 2.25 0 0 1-1.35-.46L5.19 20a2.37 2.37 0 0 1-.49-3.22 2.06 2.06 0 0 0 .23-1.86l-.06-.16a1.83 1.83 0 0 0-1.12-1.22h-.16a2.34 2.34 0 0 1-1.48-2.94L2.93 8a2.18 2.18 0 0 1 1.12-1.41 2.14 2.14 0 0 1 1.68-.12 1.93 1.93 0 0 0 1.78-.29l.13-.1a1.94 1.94 0 0 0 .73-1.51v-.24A2.32 2.32 0 0 1 10.66 2h2.55a2.26 2.26 0 0 1 1.6.67 2.37 2.37 0 0 1 .68 1.68v.28a1.76 1.76 0 0 0 .69 1.43l.11.08a1.74 1.74 0 0 0 1.59.26l.34-.11A2.26 2.26 0 0 1 21.1 7.8l.79 2.52a2.36 2.36 0 0 1-1.46 2.93l-.2.07A1.89 1.89 0 0 0 19 14.6a2 2 0 0 0 .25 1.65l.26.38a2.38 2.38 0 0 1-.5 3.23L17 21.41a2.24 2.24 0 0 1-3.22-.53l-.12-.17a1.75 1.75 0 0 0-1.5-.78 1.8 1.8 0 0 0-1.43.77l-.23.33A2.25 2.25 0 0 1 9 22a2 2 0 0 1-.39 0zM4.4 11.62a3.83 3.83 0 0 1 2.38 2.5v.12a4 4 0 0 1-.46 3.62.38.38 0 0 0 0 .51L8.47 20a.25.25 0 0 0 .37-.07l.23-.33a3.77 3.77 0 0 1 6.2 0l.12.18a.3.3 0 0 0 .18.12.25.25 0 0 0 .19-.05l2.06-1.56a.36.36 0 0 0 .07-.49l-.26-.38A4 4 0 0 1 17.1 14a3.92 3.92 0 0 1 2.49-2.61l.2-.07a.34.34 0 0 0 .19-.44l-.78-2.49a.35.35 0 0 0-.2-.19.21.21 0 0 0-.19 0l-.34.11a3.74 3.74 0 0 1-3.43-.57L15 7.65a3.76 3.76 0 0 1-1.49-3v-.31a.37.37 0 0 0-.1-.26.31.31 0 0 0-.21-.08h-2.54a.31.31 0 0 0-.29.33v.25a3.9 3.9 0 0 1-1.52 3.09l-.13.1a3.91 3.91 0 0 1-3.63.59.22.22 0 0 0-.14 0 .28.28 0 0 0-.12.15L4 11.12a.36.36 0 0 0 .22.45z"
          data-name="&lt;Group&gt;"
        />
        <path d="M12 15.5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5zm0-5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5z" />
      </g>
    </g>
  </svg>
);

export const ShareOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="share">
        <rect width="24" height="24" opacity="0" />
        <path d="M18 15a3 3 0 0 0-2.1.86L8 12.34V12v-.33l7.9-3.53A3 3 0 1 0 15 6v.34L7.1 9.86a3 3 0 1 0 0 4.28l7.9 3.53V18a3 3 0 1 0 3-3zm0-10a1 1 0 1 1-1 1 1 1 0 0 1 1-1zM5 13a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm13 6a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
      </g>
    </g>
  </svg>
);

export const Slack = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-slack"
  >
    <path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path>
    <path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path>
    <path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path>
    <path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path>
    <path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path>
    <path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path>
    <path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path>
    <path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>
  </svg>
);

export const SlideOut = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21ZM5 6C5 5.449 5.449 5 6 5H18C18.551 5 19 5.449 19 6V18C19 18.551 18.551 19 18 19H6C5.449 19 5 18.551 5 18V6Z"
      fill="currentColor"
    />
    <rect x="9" y="4" width="2" height="16" fill="currentColor" />
    <path
      d="M16.0955 14.9999C15.9704 14.9999 15.8461 14.9455 15.7613 14.8401L13.6921 12.2686C13.5644 12.1095 13.5661 11.8824 13.6968 11.7255L15.8397 9.15401C15.991 8.97229 16.2614 8.94786 16.4435 9.09915C16.6253 9.25045 16.6497 9.52088 16.498 9.70261L14.5801 12.0045L16.4294 14.3026C16.5777 14.4869 16.5485 14.7569 16.3638 14.9052C16.285 14.9691 16.1898 14.9999 16.0955 14.9999Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <mask
      id="mask0_2304_25"
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21ZM5 6C5 5.449 5.449 5 6 5H18C18.551 5 19 5.449 19 6V18C19 18.551 18.551 19 18 19H6C5.449 19 5 18.551 5 18V6Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2304_25)"></g>
  </svg>
);

export const SlideIn = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21ZM5 6C5 5.449 5.449 5 6 5H18C18.551 5 19 5.449 19 6V18C19 18.551 18.551 19 18 19H6C5.449 19 5 18.551 5 18V6Z"
      fill="currentColor"
    />
    <rect x="9" y="4" width="2" height="16" fill="currentColor" />
    <path
      d="M14.0995 9.00021C14.2247 9.00021 14.349 9.05464 14.4338 9.16008L16.503 11.7316C16.6307 11.8906 16.629 12.1178 16.4982 12.2746L14.3554 14.8461C14.2041 15.0279 13.9337 15.0523 13.7515 14.901C13.5698 14.7497 13.5454 14.4793 13.6971 14.2975L15.615 11.9956L13.7657 9.69752C13.6174 9.51323 13.6465 9.24322 13.8312 9.09493C13.9101 9.03107 14.0052 9.00021 14.0995 9.00021Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <mask
      id="mask0_2304_26"
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 21H18C19.654 21 21 19.654 21 18V6C21 4.346 19.654 3 18 3H6C4.346 3 3 4.346 3 6V18C3 19.654 4.346 21 6 21ZM5 6C5 5.449 5.449 5 6 5H18C18.551 5 19 5.449 19 6V18C19 18.551 18.551 19 18 19H6C5.449 19 5 18.551 5 18V6Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2304_26)"></g>
  </svg>
);

export const StopOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M20 5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5ZM22 19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19Z"
      fill="currentColor"
    />
  </svg>
);
export const StopCircleOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="stop-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        <path d="M14.75 8h-5.5A1.25 1.25 0 0 0 8 9.25v5.5A1.25 1.25 0 0 0 9.25 16h5.5A1.25 1.25 0 0 0 16 14.75v-5.5A1.25 1.25 0 0 0 14.75 8zM14 14h-4v-4h4z" />
      </g>
    </g>
  </svg>
);
export const SunOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 18.9999C12.5523 18.9999 13 19.4477 13 19.9999V21.9999C13 22.5522 12.5523 22.9999 12 22.9999C11.4477 22.9999 11 22.5522 11 21.9999V19.9999C11 19.4477 11.4477 18.9999 12 18.9999Z" />
    <path d="M5.63281 16.9531C6.02331 16.5627 6.65637 16.5627 7.04688 16.9531C7.4373 17.3436 7.4373 17.9766 7.04688 18.3671L5.63672 19.7773C5.24619 20.1674 4.61307 20.1676 4.22266 19.7773C3.83235 19.3869 3.83251 18.7537 4.22266 18.3632L5.63281 16.9531Z" />
    <path d="M16.9531 16.9531C17.3436 16.5625 17.9767 16.5625 18.3672 16.9531L19.7773 18.3632C20.1676 18.7538 20.1678 19.3868 19.7773 19.7773C19.3869 20.1677 18.7538 20.1675 18.3633 19.7773L16.9531 18.3671C16.5626 17.9766 16.5626 17.3436 16.9531 16.9531Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6.99994C14.7614 6.99994 17 9.23852 17 11.9999C17 14.7614 14.7614 16.9999 12 16.9999C9.23858 16.9999 7 14.7614 7 11.9999C7 9.23852 9.23858 6.99994 12 6.99994ZM12 8.99994C10.3431 8.99994 9 10.3431 9 11.9999C9 13.6568 10.3431 14.9999 12 14.9999C13.6569 14.9999 15 13.6568 15 11.9999C15 10.3431 13.6569 8.99994 12 8.99994Z"
    />
    <path d="M4 10.9999C4.55228 10.9999 5 11.4477 5 11.9999C5 12.5522 4.55228 12.9999 4 12.9999H2C1.44772 12.9999 1 12.5522 1 11.9999C1 11.4477 1.44772 10.9999 2 10.9999H4Z" />
    <path d="M22 10.9999C22.5523 10.9999 23 11.4477 23 11.9999C23 12.5522 22.5523 12.9999 22 12.9999H20C19.4477 12.9999 19 12.5522 19 11.9999C19 11.4477 19.4477 10.9999 20 10.9999H22Z" />
    <path d="M4.22266 4.2226C4.61306 3.83219 5.24617 3.83243 5.63672 4.2226L7.04688 5.63275C7.43724 6.02329 7.43735 6.65634 7.04688 7.04681C6.6564 7.43724 6.02333 7.43717 5.63281 7.04681L4.22266 5.63666C3.83251 5.24612 3.8323 4.613 4.22266 4.2226Z" />
    <path d="M18.3633 4.2226C18.7538 3.8324 19.3869 3.83227 19.7773 4.2226C20.1677 4.61303 20.1676 5.24614 19.7773 5.63666L18.3672 7.04681C17.9767 7.43723 17.3436 7.43723 16.9531 7.04681C16.5627 6.65631 16.5627 6.02325 16.9531 5.63275L18.3633 4.2226Z" />
    <path d="M12 0.999939C12.5523 0.999939 13 1.44765 13 1.99994V3.99994C13 4.55222 12.5523 4.99994 12 4.99994C11.4477 4.99994 11 4.55222 11 3.99994V1.99994C11 1.44765 11.4477 0.999939 12 0.999939Z" />
  </svg>
);

export const SquiggleOutline = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.9364 4.0017C4.93389 4.00032 4.92573 3.99676 4.91004 3.99291C4.87223 3.98369 4.79415 3.97595 4.6698 4.0017C4.41641 4.05422 4.0564 4.22861 3.67297 4.58251C3.36868 4.8634 2.89414 4.8442 2.61316 4.54003C2.33227 4.23574 2.35075 3.76119 2.65491 3.48022C3.18546 2.99048 3.78264 2.65395 4.36511 2.5332C4.94057 2.41393 5.62355 2.4941 6.07898 3.02978C6.39637 3.40317 6.53808 3.83318 6.52722 4.29028C6.51707 4.71644 6.3753 5.13122 6.20056 5.51196C5.86663 6.23945 5.24599 7.16509 4.67859 8.13622C4.13713 9.06299 3.93474 9.88651 3.96961 10.4397C3.98671 10.7108 4.05742 10.8769 4.12781 10.97C4.1887 11.0505 4.27729 11.1155 4.43982 11.1435C4.53808 11.1605 4.69068 11.1425 4.92981 10.9963C5.17159 10.8484 5.43775 10.6079 5.72449 10.2932C6.00836 9.9817 6.28217 9.63178 6.55286 9.28466C6.81154 8.95294 7.08403 8.6005 7.33289 8.34057C7.83421 7.81697 8.53537 7.06057 9.34558 6.62084C9.76593 6.39276 10.253 6.2273 10.7914 6.23412C11.3391 6.24107 11.8782 6.42562 12.3932 6.79882C13.0104 7.24611 13.3735 8.04101 13.5746 8.81957C13.6193 8.99292 13.656 9.17263 13.6881 9.35644C14.3315 9.35268 14.9274 9.40157 15.4225 9.44872C15.8347 9.48799 16.1369 9.85387 16.0978 10.2661C16.0585 10.6784 15.6927 10.9814 15.2804 10.9421C14.8117 10.8975 14.3135 10.8593 13.809 10.8564C13.8071 11.066 13.799 11.2759 13.7819 11.4841C13.7072 12.3914 13.4813 13.3216 13.0502 14.0813C12.6143 14.8493 11.9328 15.4944 10.9591 15.6677C10.2239 15.7985 9.55991 15.6478 9.06213 15.2202C8.58234 14.8079 8.35066 14.2189 8.28943 13.644C8.1692 12.5152 8.67213 11.1561 9.79822 10.3943C10.5448 9.88926 11.371 9.61732 12.1859 9.47948C12.1664 9.38194 12.146 9.28666 12.1222 9.19457C11.9505 8.52966 11.7041 8.15262 11.5128 8.01391C11.2193 7.80118 10.9761 7.73671 10.7723 7.73412C10.5594 7.73143 10.3255 7.79532 10.0604 7.9392C9.49971 8.24357 8.97007 8.79989 8.41687 9.37768C8.23293 9.56979 8.01368 9.85106 7.73572 10.2075C7.46971 10.5486 7.16194 10.9426 6.83337 11.3032C6.5078 11.6605 6.13028 12.0209 5.71204 12.2766C5.29105 12.534 4.76631 12.7218 4.18494 12.6216C3.66785 12.5324 3.23467 12.275 2.93176 11.8745C2.63839 11.4866 2.50278 11.0135 2.47254 10.5342C2.4128 9.58639 2.7499 8.46438 3.38367 7.37963C4.03494 6.26496 4.54267 5.5282 4.83753 4.88573C4.97708 4.58161 5.02487 4.38377 5.02796 4.25439C5.03024 4.15624 5.00903 4.08725 4.9364 4.0017ZM12.306 10.9788C11.7129 11.0917 11.1439 11.295 10.639 11.6365C10.0154 12.0584 9.71348 12.8542 9.78064 13.4851C9.8131 13.7899 9.9234 13.9824 10.0392 14.082C10.137 14.1661 10.323 14.2577 10.6969 14.1912C11.1059 14.1183 11.4588 13.8463 11.7457 13.3408C12.0373 12.8269 12.2233 12.1265 12.2863 11.3611C12.2967 11.2337 12.3025 11.106 12.306 10.9788Z"
      fill="currentColor"
    />
  </svg>
);

//T
export const TemplateOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 14.9999C16.5523 14.9999 17 15.4477 17 15.9999C17 16.5522 16.5523 16.9999 16 16.9999H11C10.4477 16.9999 10 16.5522 10 15.9999C10 15.4477 10.4477 14.9999 11 14.9999H16Z"
      fill="currentColor"
    />
    <path
      d="M14 10.9999C14.5523 10.9999 15 11.4477 15 11.9999C15 12.5522 14.5523 12.9999 14 12.9999H8C7.44772 12.9999 7 12.5522 7 11.9999C7 11.4477 7.44772 10.9999 8 10.9999H14Z"
      fill="currentColor"
    />
    <path
      d="M16 6.99994C16.5523 6.99994 17 7.44765 17 7.99994C17 8.55222 16.5523 8.99994 16 8.99994H9C8.44772 8.99994 8 8.55222 8 7.99994C8 7.44765 8.44772 6.99994 9 6.99994H16Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 1.99994C20.6569 1.99994 22 3.34308 22 4.99994V18.9999C22 20.6568 20.6569 21.9999 19 21.9999H5C3.34315 21.9999 2 20.6568 2 18.9999V4.99994C2 3.34308 3.34315 1.99994 5 1.99994H19ZM5 3.99994C4.44772 3.99994 4 4.44765 4 4.99994V18.9999C4 19.5522 4.44772 19.9999 5 19.9999H19C19.5523 19.9999 20 19.5522 20 18.9999V4.99994C20 4.44765 19.5523 3.99994 19 3.99994H5Z"
      fill="currentColor"
    />
  </svg>
);

export const TextOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="text">
        <rect width="24" height="24" opacity="0" />
        <path d="M20 4H4a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V6h6v13H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2V6h6v2a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const TimerOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="timer">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.994 4.03164C12.9914 4.04002 12.9889 4.0485 12.988 4.058C17.487 4.552 21 8.372 21 13C21 17.963 16.962 22 12 22C7.038 22 3 17.963 3 13C3 8.372 6.513 4.552 11.012 4.058C11.0111 4.0485 11.0086 4.04002 11.006 4.03164C11.003 4.0215 11 4.0115 11 4V3H10C9.448 3 9 2.553 9 2C9 1.447 9.448 1 10 1H14C14.552 1 15 1.447 15 2C15 2.553 14.552 3 14 3H13V4C13 4.0115 12.997 4.0215 12.994 4.03164ZM12 19.75C8.278 19.75 5.25 16.722 5.25 13C5.25 9.278 8.278 6.25 12 6.25C15.722 6.25 18.75 9.278 18.75 13C18.75 16.722 15.722 19.75 12 19.75ZM16 13C16 12.447 15.552 12 15 12H13V10C13 9.447 12.552 9 12 9C11.448 9 11 9.447 11 10V13C11 13.553 11.448 14 12 14H15C15.552 14 16 13.553 16 13Z"
        fill="currentColor"
      />
      <mask
        id="mask0_0_1974"
        maskUnits="userSpaceOnUse"
        x="3"
        y="1"
        width="18"
        height="21"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.994 4.03164C12.9914 4.04002 12.9889 4.0485 12.988 4.058C17.487 4.552 21 8.372 21 13C21 17.963 16.962 22 12 22C7.038 22 3 17.963 3 13C3 8.372 6.513 4.552 11.012 4.058C11.0111 4.0485 11.0086 4.04002 11.006 4.03164C11.003 4.0215 11 4.0115 11 4V3H10C9.448 3 9 2.553 9 2C9 1.447 9.448 1 10 1H14C14.552 1 15 1.447 15 2C15 2.553 14.552 3 14 3H13V4C13 4.0115 12.997 4.0215 12.994 4.03164ZM12 19.75C8.278 19.75 5.25 16.722 5.25 13C5.25 9.278 8.278 6.25 12 6.25C15.722 6.25 18.75 9.278 18.75 13C18.75 16.722 15.722 19.75 12 19.75ZM16 13C16 12.447 15.552 12 15 12H13V10C13 9.447 12.552 9 12 9C11.448 9 11 9.447 11 10V13C11 13.553 11.448 14 12 14H15C15.552 14 16 13.553 16 13Z"
          fill="currentColor"
        />
      </mask>
    </g>
  </svg>
);

export const TimerOffOutline = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.988 4.058C12.9889 4.0485 12.9914 4.04002 12.994 4.03164C12.997 4.0215 13 4.0115 13 4V3H14C14.552 3 15 2.553 15 2C15 1.447 14.552 1 14 1H10C9.448 1 9 1.447 9 2C9 2.553 9.448 3 10 3H11V4C11 4.0115 11.003 4.0215 11.006 4.03164C11.0086 4.04002 11.0111 4.0485 11.012 4.058C10.1864 4.14865 9.394 4.35131 8.65042 4.65041L10.4335 6.43348C10.9364 6.31352 11.4609 6.25 12 6.25C15.722 6.25 18.75 9.278 18.75 13C18.75 13.5391 18.6865 14.0636 18.5665 14.5665L20.3525 16.3525C20.7701 15.3159 21 14.1843 21 13C21 8.372 17.487 4.552 12.988 4.058ZM12 19.75C12.82 19.75 13.6063 19.603 14.334 19.334L16.0408 21.0408C14.825 21.6543 13.4521 22 12 22C7.038 22 3 17.963 3 13C3 11.8156 3.23007 10.6842 3.64786 9.64786L5.43348 11.4335C5.31353 11.9364 5.25 12.4609 5.25 13C5.25 16.722 8.278 19.75 12 19.75ZM3.85828 3.09123C3.35638 2.61722 2.56525 2.63982 2.09124 3.14172C1.61722 3.64362 1.63983 4.43475 2.14172 4.90877L20.1417 21.9088C20.6436 22.3828 21.4348 22.3602 21.9088 21.8583C22.3828 21.3564 22.3602 20.5652 21.8583 20.0912L3.85828 3.09123Z"
      fill="currentColor"
    />
  </svg>
);

export const ThumbsUpOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="None"
      d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
    ></path>
  </svg>
);

export const ThumbsDownOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      fill="None"
      d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
    ></path>
  </svg>
);

export const TokensOutline = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.32264 7.73275L6.26721 6.67733C5.93552 6.34564 5.39776 6.34564 5.06607 6.67733L4.01064 7.73275C3.67895 8.06445 3.67895 8.60221 4.01064 8.9339L5.06607 9.98933C5.39776 10.321 5.93552 10.321 6.26721 9.98933L7.32264 8.9339C7.65433 8.60221 7.65433 8.06445 7.32264 7.73275ZM4.75695 8.33333L5.66664 7.42364L6.57633 8.33333L5.66664 9.24302L4.75695 8.33333Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66672 13.3333C6.43362 13.3333 7.16019 13.1607 7.80972 12.8521C8.4596 13.1608 9.18643 13.3333 9.95243 13.3333C12.7139 13.3333 14.9524 11.0948 14.9524 8.33334C14.9524 5.57192 12.7139 3.33334 9.95243 3.33334C9.18643 3.33334 8.4596 3.50591 7.80969 3.81458C7.16019 3.50601 6.43362 3.33334 5.66672 3.33334C2.90529 3.33334 0.666718 5.57192 0.666718 8.33334C0.666718 11.0948 2.90529 13.3333 5.66672 13.3333ZM5.66672 4.28572C3.43129 4.28572 1.6191 6.09791 1.6191 8.33334C1.6191 10.5688 3.43129 12.381 5.66672 12.381C7.72319 12.381 9.42146 10.8473 9.68019 8.86141C9.70272 8.68858 9.71434 8.51232 9.71434 8.33334C9.71434 8.19363 9.70727 8.05556 9.69343 7.91949C9.48617 5.87846 7.76243 4.28572 5.66672 4.28572ZM9.95243 12.381C9.55679 12.381 9.17481 12.3243 8.81393 12.2188C9.81991 11.4029 10.5028 10.2043 10.6409 8.84456C10.658 8.67649 10.6667 8.50594 10.6667 8.33334C10.6667 8.10822 10.6518 7.88658 10.623 7.66934C10.451 6.37275 9.78208 5.23306 8.81393 4.44791C9.17481 4.34237 9.55679 4.28572 9.95243 4.28572C12.1879 4.28572 14.0001 6.09791 14.0001 8.33334C14.0001 10.5688 12.1879 12.381 9.95243 12.381Z"
      />
    </g>
  </svg>
);

export const Trace = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 5C7 4.44772 6.55228 4 6 4C5.44772 4 5 4.44772 5 5V9V15C5 16.6569 6.34315 18 8 18H13.4375C13.8375 19.0243 14.834 19.75 16 19.75C17.5188 19.75 18.75 18.5188 18.75 17C18.75 15.4812 17.5188 14.25 16 14.25C14.834 14.25 13.8375 14.9757 13.4375 16H8C7.44772 16 7 15.5523 7 15V11H13.4375C13.8375 12.0243 14.834 12.75 16 12.75C17.5188 12.75 18.75 11.5188 18.75 10C18.75 8.48122 17.5188 7.25 16 7.25C14.834 7.25 13.8375 7.97566 13.4375 9H7V5ZM16 8.75C15.3096 8.75 14.75 9.30964 14.75 10C14.75 10.6904 15.3096 11.25 16 11.25C16.6904 11.25 17.25 10.6904 17.25 10C17.25 9.30964 16.6904 8.75 16 8.75ZM14.75 17C14.75 16.3096 15.3096 15.75 16 15.75C16.6904 15.75 17.25 16.3096 17.25 17C17.25 17.6904 16.6904 18.25 16 18.25C15.3096 18.25 14.75 17.6904 14.75 17Z"
    />
  </svg>
);

export const TypeScriptSVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1562 0C17.6222 0 18 0.37776 18 0.84375V17.1562C18 17.6222 17.6222 18 17.1562 18H0.84375C0.37776 18 0 17.6222 0 17.1562V0.84375C0 0.37776 0.37776 0 0.84375 0H17.1562ZM13.8662 7.3125C13.3993 7.3125 12.9568 7.36325 12.5391 7.46387C12.1213 7.56452 11.753 7.72097 11.4355 7.93457C11.118 8.14825 10.867 8.42118 10.6826 8.75195C10.4984 9.08268 10.4062 9.47838 10.4062 9.93848C10.4063 10.526 10.5751 11.0274 10.9131 11.4424C11.251 11.8573 11.7641 12.2085 12.4521 12.4961C12.7225 12.607 12.9746 12.7164 13.208 12.8232C13.4414 12.93 13.6435 13.0403 13.8135 13.1553C13.9833 13.2702 14.1175 13.3958 14.2158 13.5312C14.3143 13.6669 14.3633 13.8216 14.3633 13.9941C14.3632 14.1215 14.3329 14.2399 14.2715 14.3486C14.21 14.4573 14.1169 14.5518 13.9922 14.6318C13.8673 14.7119 13.7116 14.7742 13.5254 14.8193C13.339 14.8645 13.12 14.8877 12.8701 14.8877C12.4442 14.8877 12.0223 14.8121 11.6045 14.6621C11.1867 14.5122 10.7997 14.2872 10.4434 13.9873V15.96C10.7629 16.1242 11.1409 16.248 11.5771 16.3301C12.0132 16.4123 12.4729 16.4531 12.9561 16.4531C13.4271 16.4531 13.875 16.4078 14.2988 16.3174C14.723 16.227 15.0954 16.0787 15.415 15.8711C15.7345 15.6635 15.9874 15.3916 16.1738 15.0566C16.36 14.722 16.4531 14.3082 16.4531 13.8154C16.4531 13.4579 16.3994 13.1442 16.293 12.875C16.1864 12.606 16.0328 12.3667 15.832 12.1572C15.6314 11.9477 15.3908 11.7592 15.1104 11.5928C14.8298 11.4265 14.5133 11.2699 14.1611 11.1221C13.9032 11.0153 13.6716 10.9112 13.4668 10.8105C13.2619 10.7099 13.0877 10.6067 12.9443 10.502C12.801 10.3972 12.6901 10.286 12.6123 10.1689C12.5346 10.0519 12.4961 9.91928 12.4961 9.77148C12.4961 9.63615 12.5302 9.51399 12.5996 9.40527C12.6693 9.29639 12.7685 9.20308 12.8955 9.125C13.0225 9.04698 13.178 8.98551 13.3623 8.94238C13.5466 8.89927 13.7514 8.87793 13.9766 8.87793C14.1405 8.87793 14.3137 8.89039 14.4961 8.91504C14.6783 8.93969 14.8616 8.97794 15.0459 9.0293C15.2302 9.08065 15.4098 9.14557 15.584 9.22363C15.7579 9.30166 15.919 9.3915 16.0664 9.49414V7.65137C15.7673 7.53632 15.4403 7.45098 15.0859 7.39551C14.7316 7.34004 14.325 7.31251 13.8662 7.3125ZM2.53125 9.07812H5.0918V16.3125H7.12988V9.07812H9.70312V7.45312H2.53125V9.07812Z"
      fill="currentColor"
    />
  </svg>
);

export const TrashOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="trash">
        <rect width="24" height="24" opacity="0" />
        <path d="M21 6h-5V4.33A2.42 2.42 0 0 0 13.5 2h-3A2.42 2.42 0 0 0 8 4.33V6H3a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8h1a1 1 0 0 0 0-2zM10 4.33c0-.16.21-.33.5-.33h3c.29 0 .5.17.5.33V6h-4zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8h12z" />
      </g>
    </g>
  </svg>
);

export const WrenchOutline = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WorkflowOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="8" height="8" x="3" y="3" rx="2" fill="none" />
    <path d="M7 11v4a2 2 0 0 0 2 2h4" fill="none" />
    <rect width="8" height="8" x="13" y="13" rx="2" fill="none" />
  </svg>
);
